<template>
  <div>
    <div class="detail_box" v-show="showDetailBox">
      <div class="detail_info_box">
        <div class="left">
          <div class="back_box">
            <div class="back_btn"><a @click="backToCard"><i class="el-icon-back" style="font-size:14px"></i><span>返回</span></a></div>
            <div class="history_btn"><a class="history" @click="loadPositionHistoryStatus">检测历史</a></div>
          </div>

          <div class="info">
            <div class="car_info">
              <div class="item">
                <el-button type="text" class="carNumber" v-clipboard:copy="dossierDetailInfo.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{  dossierDetailInfo.carNumber  }}</el-button>
                <span class="status" v-if="dossierStatus == 'checking' " style="background: #29D3BF">待检测</span>
                <span class="status" v-if="dossierStatus == 'waitQuote' " style="background: #2981D3;">待报价</span>
                <span class="status" v-if="dossierStatus == 'waitCommunicate' " style="background: #8829D3;">待商谈</span>
                <span class="status" v-if="dossierStatus == 'finish' " style="background: #ABB2BB;">已完成</span>
              </div>
              <div class="mile">里程：{{  dossierDetailInfo.mile  }}km</div>
              <el-button type="text" class="mile" style="width: 100%" v-clipboard:copy="dossierDetailInfo.frameNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">车架号：{{  dossierDetailInfo.frameNumber == null ? "-" : dossierDetailInfo.frameNumber }}</el-button>
              <div class="sa">
                <img src="../../assets/image/Avatar.png" alt="">
                <div>服务顾问·{{  dossierDetailInfo.saName  }}</div>
              </div>
            </div>
            <div class="qr_code">
              <div style="width:120px;height: 120px; position: absolute;right: 12px;top: 0;text-align: center;margin-bottom: 6px;" @click="doShowQrDialog()">
                <div style="width:120px;height: 120px;overflow: hidden;">
                  <div id="qrcode" ref="qrcode"></div>
                </div>
                <span>车辆检测档案</span>
              </div>
            </div>
          </div>
          <!--留言板-->
          <div class="message_box">
            <div class="top_box">
              <div class="title">
                <span>留言板</span>
                <a title="全部标为已读" class="brush" @click="readMsg"><i class="el-icon-brush"></i></a>
              </div>
            </div>
            <div class="block" :style="{height:messageHeight}">
              <div v-if="messageList.length>0">
                <div class="meaasge_item" v-for="(item, index) in messageList" :key="index">
                  <div class="item_box">
                    <div class="card_item">
                      <div class="position_name"><span v-show="item.positionId*1 > 0">{{item.positionName}}</span></div>
                      <div class="message">{{item.msg}}</div>
                      <div class="user_info">{{item.userName}}  {{item.submitTime}}</div>
                      <div class="has_read">
                        <span v-if="item.hasRead == 1">已读</span>
                        <span v-if="item.hasRead !== 1" style="color: red">未读</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <el-empty description="暂无留言" v-if="messageList.length <= 0"></el-empty>
            </div>
            <div class="input_box">
              <div class="input_top">
                <span>留言内容:</span>
                <a @click="clearMsg">清空</a>
              </div>
              <el-input
                      type="textarea"
                      :disabled="nochangeInput"
                      @input="inputMsg"
                      :rows="4"
                      placeholder="请输入内容"
                      maxlength="200"
                      show-word-limit
                      v-model="msg">
              </el-input>
              <div class="select_bottom_msg">
                <span>留言类型:</span>
                <div class="option_box_msg">
                  <el-radio v-model="belog" label="1" @change="changeBelog">车辆</el-radio>
                  <el-radio v-model="belog" label="2">部位</el-radio>
                </div>
                <div class="select_box_msg">
                  <el-select v-model="positionIdmsg" clearable filterable placeholder="请选择部位" :disabled="belog == 1" @change="selectPosition">
                    <el-option v-for="item in positionList" :key="item.positionId" :label="item.positionName"
                               :value="item.positionId"></el-option>
                  </el-select>
                </div>
              </div>
              <div class="btn_box">
                <el-button type="info" size="medium" icon="el-icon-edit" @click="getMsgModel" :disabled="nochangeModel">留言模板</el-button>
                <el-button type="primary" size="medium" @click="sureAddMsg">发送留言</el-button>

              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <div class="test_situation">
            <div class="situation_left">
              <div class="dot"></div>
              <span class="title">检测情况</span>
            </div>
            <div class="situation_right">
              <a class="btn" v-if="canFinishDossier" @click="finishCommunicateStatus" >{{ this.dossierDetailInfo.communicateStatus >= 1000 ? "更新销售结果" : "商谈结束" }}</a>
              <a class="btn" v-print="'#print_box'">打印检测清单</a>
            </div>
          </div>
          <!-- 检测情况列表 -->
          <div class="right_list_content" style="margin-left: 24px;margin-right: 24px;">
            <el-table v-if="DossierDetailList" :data="DossierDetailList" ref="DossierDetailList" :header-cell-style="getHeaderStyle" :cell-style="setRowStyleColor" :height="DossierDetailListHeight" style="width: 100%;">
              <el-table-column prop="positionId" label="部位ID"></el-table-column>
              <el-table-column prop="positionName" label="部位名称"></el-table-column>
              <el-table-column label="检测情况">
                <template slot-scope="scope">
                  <div class="status_box">
                    <span v-if="scope.row.positionCheckTag * 1 == 100" class="normal_text">正常</span>
                    <span v-if="scope.row.positionCheckTag * 1 == 110" class="wanging_text">警示</span>
                    <span v-if="scope.row.positionCheckTag * 1 == 120" class="abnormal_text">紧急</span>
                    <span class="department_text" v-if="scope.row.category*1 === 2 ">车间</span>
                  </div>
                </template>
              </el-table-column>
              <el-table-column label="报价状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.quoteV2Status * 1 == 0" style="color: #0D0E12">无需报价</span>
                  <span v-if="scope.row.quoteV2Status * 1 == 1000" style="color: #15B628">已报价</span>
                  <span v-if="scope.row.quoteV2Status * 1 == 100" style="color: #409EFF">待报价</span>
                  <span v-if="scope.row.quoteV2Status * 1 == 200" style="color: #409EFF">待重新报价</span>
                  <span v-if="scope.row.quoteV2Status * 1 == 300" style="color: #409EFF">暂未报价</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" width="400">
                <template slot-scope="scope">
                  <div style="display: flex">
                    <!--<div class="doit_btn" @click="loadPartsInfoSureEd(scope.row)" v-if="scope.row.quoteV2Status * 1 == 1000" >报价情况</div>-->
                    <a  class="doit_btn" @click="loadCheckDetailInfo(scope.row)">检测详情</a>
                    <a  class="doit_btn" @click="loadPartsInfoSureEd(scope.row)" v-if="scope.row.quoteV2Status * 1 == 1000" >报价情况</a>
                    <a  class="doit_btn" @click="searchPartsInfoSureEd(scope.row)">查询配件工时</a>
                    <a  class="doit_btn" @click="loadPositionHistoryCheckInfoList(scope.row)">历史工况</a>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <!--报价清单 列表-->
          <div class="test_situation">
            <div class="situation_left" >
              <div class="dot"></div>
              <a class="title" v-show="!showQuotationList" @click="showQuoteAllPosition">
                <span>报价清单</span>
                <div style="padding-top: 0;"><img src="../../assets/image/Group_93.png" alt=""></div>
              </a>
              <a class="title" v-show="showQuotationList" @click="hideQuoteAllPosition">
                <span>报价清单</span>
                <div style="padding-top: 0;"><img src="../../assets/image/Group_94.png" alt=""></div>
              </a>
            </div>
            <a v-show="showQuotationList" class="print_quote_btn" v-print="'#printBoxList'">打印报价</a>

            <div class="right_list_content" style="margin-left: 24px;margin-right: 24px;" v-show="showQuotationList">
              <el-table ref="showPartsInfoSureEd" :header-cell-style="getHeaderStyle" :cell-style="setRowStyleColor" :data="dossierPartsAllPositionList" style="width: 100%" :height="DossierDetailListHeight"  >

                <el-table-column type="index" width="40"> </el-table-column>
                <el-table-column label="类型">
                  <template slot-scope="scope">
                    <span v-if="scope.row.showType * 1 == 0">配件</span>
                    <span v-if="scope.row.showType * 1 == 1">工时</span>
                  </template>
                </el-table-column>
                <el-table-column prop="partsNo" label=" 配件/工时编号"> </el-table-column>
                <el-table-column prop="partsName" label=" 配件/工时名称"> </el-table-column>
                <el-table-column label="价格">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.price" size="small"
                              onmousewheel="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                              onkeyup="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                              onafterpaste="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                              @change="changePirce('1',scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="数量">
                  <template slot-scope="scope">
                    <el-input v-model="scope.row.numFloat" size="small" type="number"
                              onmousewheel="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                              onkeyup="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                              onafterpaste="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                              @change="changePirce('2',scope.row)"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column prop="note" label="备注" color="red">
                  <template slot-scope="scope">
                    <span style="color:#32A1C8">{{  scope.row.note  }}</span>
                  </template>
                </el-table-column>
                <el-table-column prop="brandName" align="center" label="品牌"> </el-table-column>
                <el-table-column prop="modelName" align="center" label="型号"> </el-table-column>
              </el-table>
              <div style="text-align: left;margin-top: 21px;">
                <span>合计：</span>
                <span style="font-size: 24px;color: #0D0E12;font-weight: 600;">{{priceNumSum}}</span>
                <span> 元</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div class="tab_header_box" v-show="!showDetailBox">
      <a :class="showView == 'card'?'active_view_tab':'' " class="view_tab" @click="viewTabCard" style="border-radius: 4px 0 0 4px;">看板</a>
      <a :class="showView == 'table'?'active_view_tab':'' " class="view_tab" @click="viewTabTable" style="border-radius: 0 4px 4px 0;">表格</a>
      <div style="float: left;line-height: 36px;margin-left: 30px;">
        <el-checkbox v-model="isOnlyShowSelfData" @change="updateFilterList">只显示我的服务车辆</el-checkbox>
      </div>
      <div class="reload_box">
        <span style="font-size: 14px;color: #787E86;">数据刷新时间:</span><span style="margin-left: 10px;margin-right: 10px; font-weight: bolder;color: #0D0E12">{{  lastLoadTime  }}</span>
      </div>

    </div>


    <div style="display: grid;" v-show="!showDetailBox">
      <div class="searchContent">
        <div class="p_select">
          <div class="search_label">车牌号</div>
          <el-input prefix-icon="el-icon-search" placeholder="请输入车牌号" v-model="filterCarNumber" @clear="updateFilterList" @input="updateFilterList" ></el-input>
        </div>
        <div class="p_select">
          <div class="search_label">查询日期</div>
          <el-date-picker v-model="checkDay" type="date" suffix-icon="el-icon-date" value-format="yyyy-MM-dd" @change="getListData" :picker-options="pickerDayOptions"
                          placeholder="选择查询日期"
                          clear-icon="none"></el-date-picker>
        </div>
        <div class="p_select serach_btn_box">
          <a class="search_btn" @click="getListData" style="margin-right:16px">搜索</a>
          <a class="clean_btn" @click="resetListData" >重置</a>
        </div>

      </div>
    </div>

    <el-tabs v-model="activeName" v-show="showView == 'card' && !showDetailBox" class="view_tab_box">
      <el-tab-pane label="全部" name="first">
        <div class="car_list_box">
          <div class="data_car" v-for="item in dataListAll" shadow="hover" v-bind:key="item.dossierId" >
            <a @click="loadDossierDetail(item)">
              <div class="header_box">
                <div class="carinfo">
                  <!--<el-button type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>-->
                  <el-badge v-if="item.unreadNum > 0" :value="item.unreadNum" class="item">
                    <el-button type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  </el-badge>
                  <el-button v-if="item.unreadNum <= 0" type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  <span class="mile">里程：{{item.mile}}km</span>
                </div>
                <div class="btn_box" v-if="item.status == 'checking'">
                  <span>正在检测</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitQuote'" style="background: #2981D3;">
                  <span>待报价</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitCommunicate'" style="background: #8829D3;">
                  <span>待商谈</span>
                </div>
                <div class="btn_box" v-if="item.status == 'finish'" style="background: #ABB2BB;">
                  <span>检测完成</span>
                </div>
                <div class="btn_box_category" v-if="item.workshopNums*1 > 0">
                  <span>车间 ({{item.workshopNums}})</span>
                </div>
              </div>
              <div class="test_box">
                <div class="item_box">
                  <p class="number">{{item.positionStatusList.length}}</p>
                  <p class="label">检测项</p>
                </div>
                <div class="item_box">
                  <p class="number">{{item.nomanlNum}}</p>
                  <p class="label">正常</p>
                </div>
                <div class="item_box">
                  <p class="number danger_text">{{item.positionStatusList.length - item.nomanlNum}}</p>
                  <p class="label">异常</p>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="option_box">
                <div class="left">
                  <!--<div v-for="pos in  item.positionStatusList" :key="pos.positionId" class="option_name">-->
                  <!--<span>{{  pos.positionName  }}</span>-->
                  <!--</div>-->

                  <div v-for="pos in  item.positionStatusList" v-bind:key="pos.positionId">
                    <!--<img :src="pos_tag_0" v-if="pos.checkStatus == 0" class="tagImage2">
                    <img :src="pos_tag_10" v-if="pos.checkStatus == 10 && pos.quoteV2Status != 1000" class="tagImage2">
                    <img :src="pos_tag_10_quoted" v-if="pos.checkStatus == 10 && pos.quoteV2Status == 1000" class="tagImage2">-->
                    <span class="option_name" v-if="pos.checkStatus == 10">{{  pos.positionName  }}</span>
                  </div>

                </div>
                <div class="right">{{item.saName}}</div>
              </div>
            </a>

          </div>
        </div>

      </el-tab-pane>
      <el-tab-pane :label="'待检测'+checkingList_.length " name="second">
        <div class="car_list_box">
          <div class="data_car" v-for="item in checkingList_" shadow="hover" v-bind:key="item.dossierId" >
            <a @click="loadDossierDetail(item)">
              <div class="header_box">
                <div class="carinfo">
                  <el-badge v-if="item.unreadNum > 0" :value="item.unreadNum" class="item">
                    <el-button type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  </el-badge>
                  <el-button v-if="item.unreadNum <= 0" type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  <span class="mile">里程：{{item.mile}}km</span>
                </div>
                <div class="btn_box" v-if="item.status == 'checking'">
                  <span>正在检测</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitQuote'" style="background: #2981D3;">
                  <span>待报价</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitCommunicate'" style="background: #8829D3;">
                  <span>待商谈</span>
                </div>
                <div class="btn_box" v-if="item.status == 'finish'" style="background: #ABB2BB;">
                  <span>检测完成</span>
                </div>
                <div class="btn_box_category" v-if="item.workshopNums*1 > 0">
                  <span>车间 ({{item.workshopNums}})</span>
                </div>
              </div>
              <div class="test_box">
                <div class="item_box">
                  <p class="number">{{item.positionStatusList.length}}</p>
                  <p class="label">检测项</p>
                </div>
                <div class="item_box">
                  <p class="number">{{item.nomanlNum}}</p>
                  <p class="label">正常</p>
                </div>
                <div class="item_box">
                  <p class="number danger_text">{{item.positionStatusList.length - item.nomanlNum}}</p>
                  <p class="label">异常</p>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="option_box">
                <div class="left">
                  <!--<div v-for="pos in  item.positionStatusList" :key="pos.positionId" class="option_name">-->
                  <!--<span>{{  pos.positionName  }}</span>-->
                  <!--</div>-->

                  <div v-for="pos in  item.positionStatusList" v-bind:key="pos.positionId">
                    <!--<img :src="pos_tag_0" v-if="pos.checkStatus == 0" class="tagImage2">
                    <img :src="pos_tag_10" v-if="pos.checkStatus == 10 && pos.quoteV2Status != 1000" class="tagImage2">
                    <img :src="pos_tag_10_quoted" v-if="pos.checkStatus == 10 && pos.quoteV2Status == 1000" class="tagImage2">-->
                    <span class="option_name" v-if="pos.checkStatus == 10">{{  pos.positionName  }}</span>
                  </div>

                </div>
                <div class="right">{{item.saName}}</div>
              </div>
            </a>

          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'待报价' +waitQuoteList_.length" name="third">
        <div class="car_list_box">
          <div class="data_car" v-for="item in waitQuoteList_" shadow="hover" v-bind:key="item.dossierId" >
            <a  @click="loadDossierDetail(item)">
              <div class="header_box">
                <div class="carinfo">
                  <el-badge v-if="item.unreadNum > 0" :value="item.unreadNum" class="item">
                    <el-button type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  </el-badge>
                  <el-button v-if="item.unreadNum <= 0" type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  <span class="mile">里程：{{item.mile}}km</span>
                </div>
                <div class="btn_box" v-if="item.status == 'checking'">
                  <span>正在检测</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitQuote'" style="background: #2981D3;">
                  <span>待报价</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitCommunicate'" style="background: #8829D3;">
                  <span>待商谈</span>
                </div>
                <div class="btn_box" v-if="item.status == 'finish'" style="background: #ABB2BB;">
                  <span>检测完成</span>
                </div>
                <div class="btn_box_category" v-if="item.workshopNums*1 > 0">
                  <span>车间 ({{item.workshopNums}})</span>
                </div>
              </div>
              <div class="test_box">
                <div class="item_box">
                  <p class="number">{{item.positionStatusList.length}}</p>
                  <p class="label">检测项</p>
                </div>
                <div class="item_box">
                  <p class="number">{{item.nomanlNum}}</p>
                  <p class="label">正常</p>
                </div>
                <div class="item_box">
                  <p class="number danger_text">{{item.positionStatusList.length - item.nomanlNum}}</p>
                  <p class="label">异常</p>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="option_box">
                <div class="left">
                  <!--<div v-for="pos in  item.positionStatusList" :key="pos.positionId" class="option_name">-->
                  <!--<span>{{  pos.positionName  }}</span>-->
                  <!--</div>-->

                  <div v-for="pos in  item.positionStatusList" v-bind:key="pos.positionId">
                    <!--<img :src="pos_tag_0" v-if="pos.checkStatus == 0" class="tagImage2">
                    <img :src="pos_tag_10" v-if="pos.checkStatus == 10 && pos.quoteV2Status != 1000" class="tagImage2">
                    <img :src="pos_tag_10_quoted" v-if="pos.checkStatus == 10 && pos.quoteV2Status == 1000" class="tagImage2">-->
                    <span class="option_name" v-if="pos.checkStatus == 10">{{  pos.positionName  }}</span>
                  </div>

                </div>
                <div class="right">{{item.saName}}</div>
              </div>
            </a>

          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'待商谈 ' +waitCommunicateList_.length" name="fourth">
        <div class="car_list_box">
          <div class="data_car" v-for="item in waitCommunicateList_" shadow="hover" v-bind:key="item.dossierId" >
            <a  @click="loadDossierDetail(item)">
              <div class="header_box">
                <div class="carinfo">
                  <el-badge v-if="item.unreadNum > 0" :value="item.unreadNum" class="item">
                    <el-button type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  </el-badge>
                  <el-button v-if="item.unreadNum <= 0" type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  <span class="mile">里程：{{item.mile}}km</span>
                </div>
                <div class="btn_box" v-if="item.status == 'checking'">
                  <span>正在检测</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitQuote'" style="background: #2981D3;">
                  <span>待报价</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitCommunicate'" style="background: #8829D3;">
                  <span>待商谈</span>
                </div>
                <div class="btn_box" v-if="item.status == 'finish'" style="background: #ABB2BB;">
                  <span>检测完成</span>
                </div>
                <div class="btn_box_category" v-if="item.workshopNums*1 > 0">
                  <span>车间 ({{item.workshopNums}})</span>
                </div>
              </div>
              <div class="test_box">
                <div class="item_box">
                  <p class="number">{{item.positionStatusList.length}}</p>
                  <p class="label">检测项</p>
                </div>
                <div class="item_box">
                  <p class="number">{{item.nomanlNum}}</p>
                  <p class="label">正常</p>
                </div>
                <div class="item_box">
                  <p class="number danger_text">{{item.positionStatusList.length - item.nomanlNum}}</p>
                  <p class="label">异常</p>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="option_box">
                <div class="left">
                  <!--<div v-for="pos in  item.positionStatusList" :key="pos.positionId" class="option_name">-->
                  <!--<span>{{  pos.positionName  }}</span>-->
                  <!--</div>-->

                  <div v-for="pos in  item.positionStatusList" v-bind:key="pos.positionId">
                    <!--<img :src="pos_tag_0" v-if="pos.checkStatus == 0" class="tagImage2">
                    <img :src="pos_tag_10" v-if="pos.checkStatus == 10 && pos.quoteV2Status != 1000" class="tagImage2">
                    <img :src="pos_tag_10_quoted" v-if="pos.checkStatus == 10 && pos.quoteV2Status == 1000" class="tagImage2">-->
                    <span class="option_name" v-if="pos.checkStatus == 10">{{  pos.positionName  }}</span>
                  </div>

                </div>
                <div class="right">{{item.saName}}</div>
              </div>
            </a>

          </div>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'已完成 ' +finishList_.length" name="five">
        <div class="car_list_box">
          <div class="data_car" v-for="item in finishList_" shadow="hover" v-bind:key="item.dossierId" >
            <a  @click="loadDossierDetail(item)">
              <div class="header_box">
                <div class="carinfo">
                  <el-badge v-if="item.unreadNum > 0" :value="item.unreadNum" class="item">
                    <el-button type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  </el-badge>
                  <el-button v-if="item.unreadNum <= 0" type="text" class="carNumber" v-clipboard:copy="item.carNumber" v-clipboard:success="onCopy" v-clipboard:error="onError">{{item.carNumber}}</el-button>
                  <span class="mile">里程：{{item.mile}}km</span>
                </div>
                <div class="btn_box" v-if="item.status == 'checking'">
                  <span>正在检测</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitQuote'" style="background: #2981D3;">
                  <span>待报价</span>
                </div>
                <div class="btn_box" v-if="item.status == 'waitCommunicate'" style="background: #8829D3;">
                  <span>待商谈</span>
                </div>
                <div class="btn_box" v-if="item.status == 'finish'" style="background: #ABB2BB;">
                  <span>检测完成</span>
                </div>
                <div class="btn_box_category" v-if="item.workshopNums*1 > 0">
                  <span>车间 ({{item.workshopNums}})</span>
                </div>
              </div>
              <div class="test_box">
                <div class="item_box">
                  <p class="number">{{item.positionStatusList.length}}</p>
                  <p class="label">检测项</p>
                </div>
                <div class="item_box">
                  <p class="number">{{item.nomanlNum}}</p>
                  <p class="label">正常</p>
                </div>
                <div class="item_box">
                  <p class="number danger_text">{{item.positionStatusList.length - item.nomanlNum}}</p>
                  <p class="label">异常</p>
                </div>
              </div>
              <el-divider></el-divider>
              <div class="option_box">
                <div class="left">
                  <!--<div v-for="pos in  item.positionStatusList" :key="pos.positionId" class="option_name">-->
                  <!--<span>{{  pos.positionName  }}</span>-->
                  <!--</div>-->

                  <div v-for="pos in  item.positionStatusList" v-bind:key="pos.positionId">
                    <!--<img :src="pos_tag_0" v-if="pos.checkStatus == 0" class="tagImage2">
                    <img :src="pos_tag_10" v-if="pos.checkStatus == 10 && pos.quoteV2Status != 1000" class="tagImage2">
                    <img :src="pos_tag_10_quoted" v-if="pos.checkStatus == 10 && pos.quoteV2Status == 1000" class="tagImage2">-->
                    <span class="option_name" v-if="pos.checkStatus == 10">{{  pos.positionName  }}</span>
                  </div>

                </div>
                <div class="right">{{item.saName}}</div>
              </div>
            </a>

          </div>
        </div>
      </el-tab-pane>
    </el-tabs>


    <el-tabs v-model="activeName" v-show="showView == 'table' && !showDetailBox" class="view_tab_box" >
      <el-tab-pane label="全部" name="first">
        <div class="list_content">
          <el-table :data="dataListAll" style="width: 100%;" :height="winHeight" :cell-style="setRowStyle" header-cell-class-name="table_header">
            <el-table-column prop="dossierId" label="编号"></el-table-column>
            <el-table-column prop="dossierId" label="档案ID"></el-table-column>
            <el-table-column prop="carNumber" label="车牌号"></el-table-column>
            <el-table-column prop="carNumberImageId" label="车牌照片"></el-table-column>
            <el-table-column label="里程">
              <template slot-scope="scope">
                <span>{{scope.row.mile}} Km</span>
              </template>
            </el-table-column>
            <el-table-column prop="checkDay" label="检测时间" ></el-table-column>
            <el-table-column prop="saName" label="服务顾问"></el-table-column>
            <el-table-column label="状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status == 'checking' ">待检测</span>
                <span v-if="scope.row.status == 'waitQuote' " style="color: #2981D3;">待报价</span>
                <span v-if="scope.row.status == 'waitCommunicate' " style="color: #8829D3;">待商谈</span>
                <span v-if="scope.row.status == 'finish' " style="color: #ABB2BB;">已完成</span>
              </template>
            </el-table-column>
            <el-table-column label="分享溯源" width="180px">
              <template slot-scope="scope">
                <el-button
                        @click="shareDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="详情">
              <template slot-scope="scope">
                <el-button
                        @click="loadDossierDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>

          </el-table>

        </div>
      </el-tab-pane>
      <el-tab-pane :label="'待检测 ' +checkingList_.length " name="second">
        <div class="list_content">
          <el-table :data="checkingList_" style="width: 100%;" :height="winHeight" :cell-style="setRowStyle" header-cell-class-name="table_header">
            <el-table-column prop="dossierId" label="编号"></el-table-column>
            <el-table-column prop="dossierId" label="档案ID"></el-table-column>
            <el-table-column prop="carNumber" label="车牌号"></el-table-column>
            <el-table-column prop="carNumberImageId" label="车牌照片"></el-table-column>
            <el-table-column prop="mile" label="里程"></el-table-column>
            <el-table-column prop="carNumber" label="检测情况"></el-table-column>
            <el-table-column prop="checkDay" label="检测时间" ></el-table-column>
            <el-table-column prop="saName" label="服务顾问"></el-table-column>
            <!--<el-table-column prop="communicateStatus" label="报价情况" ></el-table-column>-->
            <!--<el-table-column prop="workStatus" label="状态"></el-table-column>-->
            <el-table-column label="分享溯源" width="180px">
              <template slot-scope="scope">
                <el-button
                        @click="shareDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="详情">
              <template slot-scope="scope">
                <el-button
                        @click="loadDossierDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'待报价 ' +waitQuoteList_.length" name="third">
        <div class="list_content">
          <el-table :data="waitQuoteList_" style="width: 100%;" :height="winHeight" :cell-style="setRowStyle" header-cell-class-name="table_header">
            <el-table-column prop="dossierId" label="编号"></el-table-column>
            <el-table-column prop="dossierId" label="档案ID"></el-table-column>
            <el-table-column prop="carNumber" label="车牌号"></el-table-column>
            <el-table-column prop="carNumberImageId" label="车牌照片"></el-table-column>
            <el-table-column prop="mile" label="里程"></el-table-column>
            <el-table-column prop="carNumber" label="检测情况"></el-table-column>
            <el-table-column prop="checkDay" label="检测时间" ></el-table-column>
            <el-table-column prop="saName" label="服务顾问"></el-table-column>
            <!--<el-table-column prop="communicateStatus" label="报价情况" ></el-table-column>-->
            <!--<el-table-column prop="workStatus" label="状态"></el-table-column>-->
            <el-table-column label="分享溯源" width="180px">
              <template slot-scope="scope">
                <el-button
                        @click="shareDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="详情">
              <template slot-scope="scope">
                <el-button
                        @click="loadDossierDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'待商谈 ' +waitCommunicateList_.length" name="fourth">
        <div class="list_content">
          <el-table :data="waitCommunicateList_" style="width: 100%;" :height="winHeight" :cell-style="setRowStyle" header-cell-class-name="table_header">
            <el-table-column prop="dossierId" label="编号"></el-table-column>
            <el-table-column prop="dossierId" label="档案ID"></el-table-column>
            <el-table-column prop="carNumber" label="车牌号"></el-table-column>
            <el-table-column prop="carNumberImageId" label="车牌照片"></el-table-column>
            <el-table-column prop="mile" label="里程"></el-table-column>
            <el-table-column prop="carNumber" label="检测情况"></el-table-column>
            <el-table-column prop="checkDay" label="检测时间" ></el-table-column>
            <el-table-column prop="saName" label="服务顾问"></el-table-column>
            <!--<el-table-column prop="communicateStatus" label="报价情况" ></el-table-column>-->
            <!--<el-table-column prop="workStatus" label="状态"></el-table-column>-->
            <el-table-column label="分享溯源" width="180px">
              <template slot-scope="scope">
                <el-button
                        @click="shareDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="详情">
              <template slot-scope="scope">
                <el-button
                        @click="loadDossierDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </el-tab-pane>
      <el-tab-pane :label="'已完成 ' +finishList_.length" name="five">
        <div class="list_content">
          <el-table :data="finishList_" style="width: 100%;" :height="winHeight" :cell-style="setRowStyle" header-cell-class-name="table_header">
            <el-table-column prop="dossierId" label="编号"></el-table-column>
            <el-table-column prop="dossierId" label="档案ID"></el-table-column>
            <el-table-column prop="carNumber" label="车牌号"></el-table-column>
            <el-table-column prop="carNumberImageId" label="车牌照片"></el-table-column>
            <el-table-column prop="mile" label="里程"></el-table-column>
            <el-table-column prop="carNumber" label="检测情况"></el-table-column>
            <el-table-column prop="checkDay" label="检测时间" ></el-table-column>
            <el-table-column prop="saName" label="服务顾问"></el-table-column>
            <!--<el-table-column prop="communicateStatus" label="报价情况" ></el-table-column>-->
            <!--<el-table-column prop="workStatus" label="状态"></el-table-column>-->
            <el-table-column label="分享溯源" width="180px">
              <template slot-scope="scope">
                <el-button
                        @click="shareDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>
            <el-table-column fixed="right" label="详情">
              <template slot-scope="scope">
                <el-button
                        @click="loadDossierDetail(scope.row)"
                        type="warning"
                        size="small"
                        class="update_btn"
                >查看</el-button>
              </template>
            </el-table-column>

          </el-table>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-dialog title="报告二维码" center :visible.sync="showQrDialog" width="400px" :close-on-click-modal="false">
      <div style="width:100%;height: 300px;display: flex;">
        <div id="qrcodeBig" ref="qrcodeBig" style="width:200px;height: 200px;align-self: center;margin: 0 auto;"></div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showQrDialog = false">关闭</el-button>
      </span>
    </el-dialog>

    <!-- 部位检测情况对话框 -->
    <el-dialog :title="getCheckDetailTiltle" center :visible.sync="showPositionCheckDetail" width="80%" :close-on-click-modal="true">
      <el-divider></el-divider>
      <div>
        <div class="text_box">
          <div class="text_content">
            <!--部位说明-->
            <div class="option_explain">
              <p>部位说明：</p>
              <div>
                <span v-for="item of PositionCheckDetailData.textTemplates" :key="item.instructionText">{{  item.instructionText }}</span>
              </div>
            </div>
            <!--不维修风险-->
            <div class="risk_explain">
              <p>不维修风险：</p>
              <div><span v-for="item of PositionCheckDetailData.textTemplates" :key="item.warningText">{{  item.warningText }}</span></div>
            </div>
          </div>
          <!--<div class="refer_to_content" v-if="this.PositionCheckDetailData.imageVersion > 0">
            <p>参考标准：</p>
            <div><img :src="PositionCheckDetailData.standardImage" ></div>
          </div>-->
          <div class="refer_to_content" v-if="this.PositionCheckDetailData.imageVersion > 0">
            <p>参考标准：</p>
            <div class="img_item" v-if="dossierDetailInfo.showVersion*1 === 2">
              <a  class="icon_box" @click="trunLeftStandImg" style="float: left;"><i class="el-icon-arrow-left"></i></a>
              <div class="img_list">
                <div class="img_flex_box" :style="{marginLeft:leftNum_stand+'px'}">
                  <div v-for="item of PositionCheckDetailData.standardImages" :key="item.index" class="img_flex_box_item">
                    <div class="label_img" v-if="item.statusType0 > 0">
                      <img :src="`${baseUrl}admin/sa/dossier/images/getVHCImg/${item.statusType0}`" />
                      <p>全新</p>
                    </div>
                    <div class="label_img" v-if="item.statusType10 > 0">
                      <img :src="`${baseUrl}admin/sa/dossier/images/getVHCImg/${item.statusType10}`" />
                      <div class="label_box">
                        <img src="../../assets/image/statusTypeImg10.png"  v-if="PositionCheckDetailData.positionCheckTag == 100" >
                        <span :style="PositionCheckDetailData.positionCheckTag == 100 ? '' : 'margin: 0 auto' ">正常</span>
                      </div>
                    </div>
                    <div class="label_img" v-if="item.statusType20 > 0">
                      <img :src="`${baseUrl}admin/sa/dossier/images/getVHCImg/${item.statusType20}`" />
                      <div class="label_box">
                        <img src="../../assets/image/statusTypeImg20.png" v-if="PositionCheckDetailData.positionCheckTag == 110">
                        <span :style="PositionCheckDetailData.positionCheckTag == 110 ? '' : 'margin: 0 auto' ">可使用</span>
                      </div>
                    </div>
                    <div class="label_img" v-if="item.statusType30 > 0">
                      <img :src="`${baseUrl}admin/sa/dossier/images/getVHCImg/${item.statusType30}`" />
                      <div class="label_box">
                        <img src="../../assets/image/statusTypeImg30.png" v-if="PositionCheckDetailData.positionCheckTag == 120">
                        <span :style="PositionCheckDetailData.positionCheckTag == 120 ? '' : 'margin: 0 auto' ">需处理</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <a  class="icon_box" @click="trunRightStandImg" style="float: right;"><i class="el-icon-arrow-right"></i></a>
            </div>

            <div class="version_first" v-else><img :src="PositionCheckDetailData.standardImage" ></div>
            <!--<div class="version_first"><img :src="PositionCheckDetailData.standardImage" ></div>-->
          </div>
        </div>
        <el-divider style="margin: 0 0 24px 0;"></el-divider>
        <div class="details_box">
          <div class="detail_info">
            <div class="detection">
              <p>检测情况：</p>
              <div>
                <div v-for="item of PositionCheckDetailData.textValueList" style="display: inline;" :key="item.id">
                  <div style="display: inline-block;">
                    <span style="line-height: 20px;font-size: 12px;color: gray;">{{  item.headerLabel  }}: </span>
                    <span style="font-size: 24px;color: gray;font-weight: 500;">{{  item.valueText  }}{{  item.suffix  }}</span>
                  </div>
                </div>


              </div>

            </div>
            <div class="harm">
              <p>诊断结果及危害：</p>
              <div>{{  PositionCheckDetailData.diagnosis  }}</div>
            </div>
            <div class="harm">
              <p v-if="PositionCheckDetailData.positionCheckTag == 100" style="color: #29D3BF;">诊断结果：检测正常</p>
              <p v-if="PositionCheckDetailData.positionCheckTag == 110" style="color: #E1BD3E;">诊断结果：可使用观察</p>
              <p v-if="PositionCheckDetailData.positionCheckTag == 120" style="color: #E04066;">诊断结果：本次建议处理</p>
            </div>
            <div class="harm">
              <span>检测技师：</span>
              <span style="font-size: 24px;color: gray;font-weight: 500;">{{  PositionCheckDetailData.workUserName  }}</span>
            </div>
          </div>
          <div class="img_box">
            <p>影像检测：</p>
            <div class="img_item">
              <a  class="icon_box" @click="trunLeft" style="float: left;"><i class="el-icon-arrow-left"></i></a>
              <div class="img_list">
                <div class="img_flex_box" :style="{marginLeft:leftNum+'px'}">

                  <div v-if="videoList.length > 0">
                    <div v-for="item of videoList" :src="item.imageUrl" :key="item.videoId"
                         style="width:200px;height: 150px;align-self: center;align-items: center;margin-right: 16px">
                      <video :src="item.playAddress" controls="controls" class="video-player vjs-custom-skin" style="width: 200px;height: 150px;">
                        您的浏览器不支持 video 标签。
                      </video>
                    </div>
                  </div>

                  <img v-for="item of PositionCheckDetailData.imageValueList" :src="item.imageUrl" :key="item.imageUrl"
                       @click="showImageDialog(item.imageUrl)"
                       style="width:200px;height: 150px;align-self: center;align-items: center;" />
                </div>
              </div>
              <a  class="icon_box" @click="trunRight(PositionCheckDetailData.imageValueList)" style="float: right;"><i class="el-icon-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>


    <el-dialog title="查看图片" center :visible.sync="showBigImage" width="700px" :close-on-click-modal="true">
      <div style="display: flex;flex-wrap: wrap;flex-direction: row;">
        <img :src="showBigImageUrl"
             style="width:640px;height: 480px;margin: 3px auto;border:1px solid #409EFF;align-self: center;align-items: center;" />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showBigImage = false">关闭窗口</el-button>
      </span>
    </el-dialog>


    <!--配件/工时信息-->
    <el-drawer
            title="配件/工时信息"
            :visible.sync="showPartsInfoSureEd"
            size="50%"
            :wrapperClosable="true"
            direction="rtl"
            @close="showPartsInfoSureEd = false"
    >
      <div style="margin-left:24px;margin-right: 24px">
        <el-table ref="showPartsInfoSureEd" :header-cell-style="getHeaderStyle" :cell-style="setRowStyleColor" :data="partsInfoList"
                  style="width: 100%" show-summary :summary-method="getSummariesWhenPreviewQuote">
          <el-table-column align="center" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.showType * 1 == 0">配件</span>
              <span v-if="scope.row.showType * 1 == 1">工时</span>
            </template>
          </el-table-column>
          <el-table-column prop="partsNo" align="center" label=" 配件/工时编号"> </el-table-column>
          <el-table-column prop="partsName" align="center" label=" 配件/工时名称"> </el-table-column>
          <el-table-column prop="price" align="center" label="价格"> </el-table-column>
          <el-table-column prop="numFloat" align="center" label="数量"></el-table-column>
          <el-table-column prop="note" align="center" label="备注" color="red">
            <template slot-scope="scope">
              <span style="color:#32A1C8">{{  scope.row.note  }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brandName" align="center" label="品牌"> </el-table-column>
          <el-table-column prop="modelName" align="center" label="型号"> </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showPartsInfoSureEd = false">关闭窗口</el-button>
      </span>
    </el-drawer>
    <!--车辆（配件/工时）清单-->
    <el-drawer
            title="车辆（配件/工时）清单"
            :visible.sync="showPartsAllPosition"
            size="50%"
            :wrapperClosable="true"
            direction="rtl"
            @close="showPartsAllPosition = false"
    >
      <div style="margin-left:24px">
        <el-table ref="showPartsAllPosition" :header-cell-style="getHeaderStyle"
                  :data="dossierPartsAllPositionList" style="width: 100%" height="500" show-summary
                  :summary-method="getSummariesWhenPreviewQuote2">
          <el-table-column align="center" label="类型">
            <template slot-scope="scope">
              <span v-if="scope.row.showType * 1 == 0">配件</span>
              <span v-if="scope.row.showType * 1 == 1">工时</span>
            </template>
          </el-table-column>
          <el-table-column prop="positionName" align="center" label="部位"> </el-table-column>
          <el-table-column prop="partsNo" align="center" label="配件/工时编号"> </el-table-column>
          <el-table-column prop="partsName" align="center" label="配件/工时名称"> </el-table-column>
          <el-table-column prop="price" align="center" label="价格"> </el-table-column>
          <el-table-column prop="numFloat" align="center" label="数量"></el-table-column>
          <el-table-column prop="note" align="center" label="备注" color="red">
            <template slot-scope="scope">
              <span style="color:#32A1C8">{{  scope.row.note  }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="brandName" align="center" label="品牌"> </el-table-column>
          <el-table-column prop="modelName" align="center" label="型号"> </el-table-column>
        </el-table>
      </div>

      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="closePartsAllPosition = false">关闭窗口</el-button>
        <el-button type="success" size="small" v-print="'#printBoxList'">打印报价清单</el-button>
      </span>
    </el-drawer>
    <!--部位历史检测情况-->
    <el-drawer
            title="部位历史检测情况"
            size="65%"
            :wrapperClosable="true"
            :visible.sync="showPositionHistoryCheckInfoList"
            direction="rtl"
            @close="showPositionHistoryCheckInfoList = false">
      <el-divider></el-divider>
      <div style="margin-left:24px;margin-right: 24px;padding-bottom: 24px;">
        <el-table :data="positionHistoryCheckInfoList" :header-cell-style="getHeaderStyle" :cell-style="setRowStyleColor" :height="positionHistoryHeight"
                  style="width: 100%;">
          <el-table-column prop="dossierId" label="档案ID"></el-table-column>
          <el-table-column prop="saName" label="SA"></el-table-column>
          <el-table-column prop="checkDay" label="检测日期" width="120"></el-table-column>

          <el-table-column label="诊断结果">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.tag * 1 == 10" style="background: #E04066;" class="danger_box">异常</span>
                <span v-else style="background: #67C23A" class="danger_box">正常</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column prop="money" label="价格小计" sortable>
            <template slot-scope="scope">
              <span v-if="scope.row.money * 1 === 0" style="color: #979797">-</span>
              <span v-else style="color: #979797">{{  scope.row.money  }}</span>
            </template>
          </el-table-column>
          <el-table-column label="报价状态">
            <template slot-scope="scope">
              <span v-if="scope.row.quoteV2Status * 1 == 0" style="color: #979797">无需报价</span>
              <span v-if="scope.row.quoteV2Status * 1 == 1000" style="color: #15B628">已报价</span>
              <span v-if="scope.row.quoteV2Status * 1 == 100" style="color: #409EFF">待报价</span>
              <span v-if="scope.row.quoteV2Status * 1 == 200" style="color: #409EFF">待重新报价</span>
              <span v-if="scope.row.quoteV2Status * 1 == 300" style="color: #409EFF">暂未报价</span>
            </template>
          </el-table-column>
          <el-table-column label="商谈结果">
            <template slot-scope="scope">
              <div v-if="scope.row.tag === 10">
                <span v-if="scope.row.usFeedback * 1 == 800" style="color: #409EFF">已同意换件/维修</span>
                <span v-if="scope.row.usFeedback * 1 == 400">暂不处理</span>
                <span v-if="scope.row.usFeedback * 1 == 0">未登记</span>
              </div>
              <div v-if="scope.row.tag === 0">
                <span v-if="scope.row.usFeedback * 1 == 800" style="color: #ff4d00">已同意换件/维修</span>
                <span v-else>-</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="失销原因" prop="reasonLabel" align="left"></el-table-column>
          <el-table-column prop="diagnosis" align="left" label="诊断结果" width="300"></el-table-column>
          <el-table-column label="检测详情">
            <template slot-scope="scope">
              <el-button type="success" size="small" @click="loadCheckDetailInfo(scope.row)" class="detail_btn_box">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <br />
      <span slot="footer" class="dialog-footer" style="margin-top: 10px;">
        <el-button type="info" size="small" @click="showPositionHistoryCheckInfoList = false">关闭窗口</el-button>
      </span>
    </el-drawer>
    <!--车辆历史检测情况-->
    <el-drawer
            title="车辆历史检测情况"
            :visible.sync="showPositionHistoryStatus"
            size="60%"
            :wrapperClosable="true"
            direction="rtl"
            @close="showPositionHistoryStatus = false">
      <!--:cell-style="tableHeaderColor"-->
      <div style="margin-left:24px;margin-right: 24px">
        <el-table :data="PositionHistoryStatus" stripe
                  :header-cell-style="getHeaderStyleNone" :cell-style="setRowStyleColorNone" >
          <el-table-column v-for="(keyItem, index) in PositionHistoryStatus[0]" :key="index" :prop="(index)"
                           align="center">
            <template slot-scope="scope">
              <!--<span>{{index}}</span>-->
              <img :src="pos_tag_0" v-if="scope.row[index] == 'pos_tag_0'" class="tagImage2">
              <img :src="pos_tag_10" v-if="scope.row[index] == 'pos_tag_10'" class="tagImage2">
              <img :src="pos_tag_400" v-if="scope.row[index] == 'pos_tag_400'" class="tagImage2">
              <img :src="pos_tag_800" v-if="scope.row[index] == 'pos_tag_800'" class="tagImage2">

              <span
                      v-if="(scope.row[index] !== 'pos_tag_0') && (scope.row[index] !== 'pos_tag_10') && (scope.row[index] !== 'pos_tag_400') && (scope.row[index] !== 'pos_tag_800')">{{
               scope.row[index]  }}</span>

            </template>
          </el-table-column>
        </el-table>
      </div>
      <br />
      <span slot="footer" class="dialog-footer" style="margin-top: 10px;">
        <el-button type="info" size="small" @click="showPositionHistoryStatus = false">关闭窗口</el-button>
      </span>
    </el-drawer>
    <!--查询 配件/工时信息-->
    <el-drawer
            title="查询 配件/工时信息"
            left
            size="50%"
            :wrapperClosable="true"
            :visible.sync="showSearchPartsInfoSureEd"
            direction="rtl">
      <div style="margin-left:24px;margin-right: 24px">
        <div>
          <div class="dia_box_dot">
            <div class="dot"></div>
            <span>配件信息</span>
          </div>
          <el-table ref="showSearchPartsInfoSureEdPart" :header-cell-style="getHeaderStyle" :cell-style="setRowStyleColor"
                    :data="showSearchPartsInfoSureEdPart" height="300" style="width: 100%;min-height:200px;">
            <el-table-column prop="partsNo" align="center" label=" 配件编号"> </el-table-column>
            <el-table-column prop="partsName" align="center" label=" 配件名称"> </el-table-column>
            <el-table-column prop="price" align="center" label="价格"> </el-table-column>
            <el-table-column prop="numFloat" align="center" label="数量"></el-table-column>
            <el-table-column prop="brandName" align="center" label="品牌"> </el-table-column>
            <el-table-column prop="modelName" align="center" label="型号"> </el-table-column>
          </el-table>
        </div>

        <div>
          <div class="dia_box_dot">
            <div class="dot"></div>
            <span>工时信息</span>
          </div>
          <el-table ref="showSearchPartsInfoSureEdWorkTime" :header-cell-style="getHeaderStyle" :cell-style="setRowStyleColor"
                    :data="showSearchPartsInfoSureEdWorkTime" height="300" style="width: 100%;min-height:200px;">
            <el-table-column prop="partsNo" align="center" label="工时编号"> </el-table-column>
            <el-table-column prop="partsName" align="center" label="工时名称"> </el-table-column>
            <el-table-column prop="price" align="center" label="价格"> </el-table-column>
            <el-table-column prop="numFloat" align="center" label="数量"></el-table-column>
            <el-table-column prop="brandName" align="center" label="品牌"> </el-table-column>
            <el-table-column prop="modelName" align="center" label="型号"> </el-table-column>
          </el-table>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="info" size="small" @click="showSearchPartsInfoSureEd = false">关闭窗口</el-button>
      </span>
    </el-drawer>
    <!--商谈结果 & 失销原因-->
    <el-drawer
            title="商谈结果 & 失销原因"
            :visible.sync="showCommunicateResultDialog"
            size="50%"
            :wrapperClosable="true"
            direction="rtl"
            @close="showCommunicateResultDialog = false">
      <el-table :data="DossierDetailListForFeedBack" border :header-cell-style="getHeaderStyle" show-summary :summary-method="getSummariesWhenFinished" >
        <el-table-column prop="positionId" align="center" label="部位ID" width="80px"></el-table-column>
        <el-table-column prop="positionName" align="center" label="部位名称"></el-table-column>
        <el-table-column align="center" label="检测情况">
          <template slot-scope="scope">
            <span v-if="scope.row.tag * 1 == 10" style="color: #ff4d00">异常</span>
            <span v-else style="color: #15B628">正常</span>
          </template>
        </el-table-column>
        <el-table-column prop="money" align="center" label="报价小计" sortable>
          <template slot-scope="scope">
            <span v-if="scope.row.money * 1 === 0" style="color: #979797">-</span>
            <span v-else style="color: #979797">{{ scope.row.money }}</span>
          </template>
        </el-table-column>
        <el-table-column align="center" label="商谈结果">
          <template slot-scope="scope">
            <div v-if="scope.row.tag === 10">
              <span v-if="scope.row.usFeedback * 1 == 800" style="color: #409EFF">已同意换件/维修</span>
              <span v-if="scope.row.usFeedback * 1 == 400">暂不处理</span>
              <span v-if="scope.row.usFeedback * 1 == 0">未登记</span>
            </div>
            <div v-if="scope.row.tag === 0">
              <span v-if="scope.row.usFeedback * 1 == 800" style="color: #ff4d00">已同意换件/维修</span>
              <span v-else>-</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="商谈情况" width="180px">
          <template slot-scope="scope">
            <el-select v-model="scope.row.usFeedback" placeholder="请选择">
              <el-option v-for="item in soledOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </template>
        </el-table-column>
        <el-table-column align="center" label="失销原因" width="180px">
          <template slot-scope="scope">
            <div v-if="scope.row.tag === 10 && scope.row.usFeedback === 400">
              <el-select v-model="scope.row.reason" placeholder="请选择">
                <el-option v-for="item in reasonArr" :key="item.reasonId" :label="item.label" :value="item.reasonId">
                </el-option>
              </el-select>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="数量" width="180px">
          <template slot-scope="scope">
            <div v-if="scope.row.usFeedback === 800 ">
              <el-input v-model="scope.row.dealFeedback" size="small" type="number"
                        onmousewheel="!/^[1-9]\d*$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                        onkeyup="!/^[1-9]\d*$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
                        onafterpaste="!/^(\d+\.?)?\d{0,2}$/.test(this.value)?(this.value=this.value.substring(0, this.value.length-1)): ''"
              ></el-input>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="销售类型" width="180px">
          <template slot-scope="scope">
            <div v-show="scope.row.usFeedback === 800 ">
              <el-radio-group v-model="scope.row.belongTo" style="text-align: left;">
                <el-radio label="1">前台前置销售</el-radio>
                <el-radio label="2" style="margin-top: 4px">车间增项销售</el-radio>
              </el-radio-group>
            </div>
          </template>
        </el-table-column>
        <el-table-column align="center" label="成交金额" width="180px">
          <template slot-scope="scope">
            <div v-if="scope.row.usFeedback === 800 ">
              <el-input v-model="scope.row.price" size="small" type="number"
              ></el-input>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div class="position_box_btn">

        <a class="operate_btn" @click="abnormalReplaced">全部异常已换</a>
        <a class="operate_btn" @click="abnormalNoChange">全部异常不换</a>

        <a class="sure_btn" @click="doFinishCommunicateStatus">完成记录</a>
        <a class="cancel_btn" @click="showCommunicateResultDialog = false">取消</a>
      </div>
    </el-drawer>

    <!--留言模板选择-->
    <el-drawer
            title="选择留言模板"
            :visible.sync="showMsgModel"
            size="60%"
            :wrapperClosable="true"
            direction="rtl"
            @close="showMsgModel = false">
      <div style="margin-left:24px">
        <div style="overflow: hidden">
          <el-table :header-cell-style="getHeaderStyle" :data="msgList" style="width: 48%; float: left; margin-right: 1%" :height="drawerMsgHeight" @row-dblclick="getMsgDetail">
            <el-table-column prop="dictionaryId" align="left" label="ID"> </el-table-column>
            <el-table-column prop="dictionaryName" align="left" label="留言字典"> </el-table-column>
            <el-table-column prop="orderIndex" align="left" label="排序字段" sortable> </el-table-column>
          </el-table>

          <div style="width: 50%; float: left">
            <p>字典名称:{{dictionaryName}}</p>
            <el-table ref="multipleTable" :data="msgDetailList" tooltip-effect="dark" :key="randomKey" :height="drawerMsgHeight-16" :header-cell-class-name="cellClass" @selection-change="handleSelectionChange" >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column prop="dictionaryItemId" label="ID" > </el-table-column>
              <el-table-column prop="text" label="内容" > </el-table-column>
              <el-table-column prop="orderIndex" label="排序字段" sortable> </el-table-column>
            </el-table>
          </div>
        </div>

        <div class="msg_detail_box">
          <span v-for="(item, index) in multipleSelection" :key="index">{{item.text}}    </span>
        </div>
        <br />
        <div class="position_box_btn">
          <a class="sure_btn" @click="selectedMsg">确定</a>
          <a class="cancel_btn" @click="showMsgModel = false">取消</a>
        </div>

      </div>
    </el-drawer>



    <!--打印-->
    <div style="width: 0;height: 0;overflow: hidden">
      <!--检测清单-->
      <div id="print_box" class="print_box">
        <div class="print_con" style="width: 190mm;height: 297mm;font-family: '宋体';background: #fff">
          <div class="head" style="height: 40px;border-bottom: 1px solid #333;">
            <div class="logo_left" style="float: left;">
              <img style="height: 32px;" :src="dossierDetailInfo.leftLogo" alt="">
            </div>
            <div class="logo_right" style="float: right;margin-right: 2px">
              <img style="height: 32px;" :src="dossierDetailInfo.rightLogo" alt="">
            </div>
          </div>
          <!--车辆信息-->
          <div class="title_box">
            <div class="title" style="height: 60px;line-height: 60px;font-size: 32px;text-align: center;font-weight: 700">
              <p>车辆健康检查报告单</p>
            </div>
            <div class="info_box" style="display: flex;">
              <div class="info_left" style="width: 43%;font-size: 12px">
                <div style="display: flex; flex-direction: column; text-align: left;color: #333">
                  <span style="font-size: 14px; margin-bottom: 10px;">车辆车牌: {{  dossierDetailInfo.carNumber  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">档案编号: {{  dossierDetailInfo.dossierId  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">服务顾问: {{  dossierDetailInfo.saName  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">检测地点: {{  dossierDetailInfo.orgName  }}</span>
                  <div style="margin-top: 14px;color: #333;font-weight: 700">
                    <span>检测部位情况</span>
                  </div>
                </div>

              </div>
              <div class="info_cen" style="width: 37%;font-size: 12px">
                <div style="display: flex; flex-direction: column; text-align: left;color: #333">
                <span style="font-size: 14px; margin-bottom: 10px;">品牌型号: {{  dossierDetailInfo.brandName  }}
                  {{  dossierDetailInfo.seriesName  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">车辆里程: {{  dossierDetailInfo.mile  }}Km</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">检测日期: {{  dossierDetailInfo.checkDay  }}</span>
                </div>
              </div>
              <div class="info_right" style="width: 20%;height: 120px;">
                <div id="qrcode_print" ref="qrcode_print" style="width: 120px; height: 120px"></div>
              </div>
            </div>
          </div>
          <!--部位信息-->

          <div class="list_box" style="margin-top: 10px;">
            <el-table class="print_table" :data="positionInfoListPrint" border
                      :cell-style="{ borderRight: '1px dashed #000', borderBottom: '1px dashed #000', padding: '0', color: '#000' }"
                      :header-cell-style="{ textAlign: 'center', borderRight: '1px dashed #000', borderBottom: '1px dashed #000', color: '#000' }"
                      :row-style="{ height: '53px' }">
              <el-table-column prop="colIndex" align="left" width="40"> </el-table-column>
              <el-table-column prop="positionName" align="center" label="部位" width="90px" style="font-size: 14px">
              </el-table-column>
              <el-table-column prop="diagnosis" align="left" label="检测情况" width="385px" style="font-size: 12px">
              </el-table-column>
              <el-table-column align="center" label="处理方案" width="120px" style="font-size: 14px">
                <template slot-scope="scope">
                  <span v-if="scope.row.positionCheckTag * 1 == 0 && scope.row.tag * 1 == 0">检测正常</span>
                  <span v-if="scope.row.positionCheckTag * 1 == 0 && scope.row.tag * 1 !== 0">本次建议处理</span>
                  <span v-if="scope.row.positionCheckTag * 1 == 100">检测正常</span>
                  <span v-if="scope.row.positionCheckTag * 1 == 110">可使用观察</span>
                  <span v-if="scope.row.positionCheckTag * 1 == 120">本次建议处理</span>
                </template>
              </el-table-column>
              <el-table-column prop="templateDesc" align="center" label="备注" width="80px" style="font-size: 14px">
              </el-table-column>
            </el-table>
          </div>

          <div class="notice_box" style="margin-top: 20px;margin-left: 10px;text-align: left;color: #000;font-size: 14px">
            <span>注：检查结果仅反映当时当次车辆的健康情况</span>
          </div>
          <div class="sure_box" style="margin-top: 20px;">
            <div class="sure" style="width: 235px;float: right;display: flex;">
              <span style="width: 80px;color: #000;font-size: 14px">服务顾问:</span>
              <div style="width: 160px;border-bottom: 1px solid #000;margin-left: 10px;"></div>
            </div>
            <div class="sure" style="margin-right: 30px;width: 235px;float: right;display: flex;">
              <span style="width: 80px;color: #000;font-size: 14px">客户签名:</span>
              <div style="width: 160px;border-bottom: 1px solid #000;margin-left: 10px;"></div>
            </div>
          </div>

        </div>
      </div>
      <!--报价清单-->
      <div id="printBoxList" class="print_box">
        <div class="print_con" style="width: 190mm;height: 297mm;font-family: '宋体';background: #fff">
          <div class="head" style="height: 40px;border-bottom: 1px solid #333;">
            <div class="logo_left" style="float: left;">
              <img style="height: 32px;" :src="dossierDetailInfo.leftLogo" alt="">
            </div>
            <div class="logo_right" style="float: right;margin-right: 2px">
              <img style="height: 32px;" :src="dossierDetailInfo.rightLogo" alt="">
            </div>
          </div>
          <!--车辆信息-->
          <div class="title_box">
            <div class="title" style="height: 60px;line-height: 60px;font-size: 32px;text-align: center;font-weight: 700">
              <p>维修检测报告</p>
            </div>
            <div class="info_box" style="display: flex;">
              <div class="info_left" style="width: 43%;font-size: 12px">
                <div style="display: flex; flex-direction: column; text-align: left;color: #333">
                  <span style="font-size: 14px; margin-bottom: 10px;">车辆车牌: {{  dossierDetailInfo.carNumber  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">档案编号: {{  dossierDetailInfo.dossierId  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">服务顾问: {{  dossierDetailInfo.saName  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">检测地点: {{  dossierDetailInfo.orgName  }}</span>
                  <div style="margin-top: 14px;color: #333;font-weight: 700">
                    <span>检测部位报价情况</span>
                  </div>
                </div>

              </div>
              <div class="info_cen" style="width: 37%;font-size: 12px">
                <div style="display: flex; flex-direction: column; text-align: left;color: #333">
                <span style="font-size: 14px; margin-bottom: 10px;">品牌型号: {{  dossierDetailInfo.brandName  }}
                  {{  dossierDetailInfo.seriesName  }}</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">车辆里程: {{  dossierDetailInfo.mile  }}Km</span>
                  <span style="font-size: 14px; margin-bottom: 10px;">检测日期: {{  dossierDetailInfo.checkDay  }}</span>
                </div>
              </div>
              <div class="info_right" style="width: 20%;height: 120px;">
                <div id="qrcode_print_list" ref="qrcode_print_list" style="width: 120px; height: 120px"></div>
              </div>
            </div>
          </div>
          <!--报价信息-->

          <div class="list_box" style="margin-top: 10px;">
            <el-table class="print_table" :data="dossierPartsAllPositionListPrint" border
                      :header-cell-style="{ textAlign: '/center', borderRight: '1px dashed #000', borderBottom: '1px dashed #000', color: '#000' }"
                      :row-style="{ height: '53px' }"
                      :cell-style="{ borderRight: '1px dashed #000', borderBottom: '1px dashed #000', padding: '0', color: '#000' }"
                      show-summary :summary-method="getSummariesWhenPreviewQuote3">
              <el-table-column prop="colIndex" align="left" width="40"> </el-table-column>
              <el-table-column prop="positionName" align="center" label="部位" width="80"> </el-table-column>
              <el-table-column align="center" label="类型" width="60">
                <template slot-scope="scope">
                  <span v-if="scope.row.showType * 1 == 0">配件</span>
                  <span v-if="scope.row.showType * 1 == 1">工时</span>
                </template>
              </el-table-column>
              <el-table-column align="center" label="配件/工时" width="265">
                <template slot-scope="scope">
                  <span>{{  scope.row.partsName  }}</span>
                  <br />
                  <span>{{  scope.row.partsNo  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="price" align="center" label="单价" width="80"> </el-table-column>
              <el-table-column prop="numFloat" align="center" label="数量" width="50"></el-table-column>
              <el-table-column align="center" label="小计" width="80">
                <template slot-scope="scope">
                  <span v-if="scope.row.price > 0">{{(scope.row.price * scope.row.numFloat).toFixed(2)  }}</span>
                  <span v-else> </span>
                </template>
              </el-table-column>
              <el-table-column prop="note" align="center" label="备注" width="60">
                <template slot-scope="scope">
                  <span style="color:#32A1C8">{{  scope.row.note  }}</span>
                </template>
              </el-table-column>
            </el-table>
          </div>

          <div class="notice_box" style="margin-top: 20px;margin-left: 10px;text-align: left;color: #000;font-size: 14px">
            <span>注：报价结果仅反应配件价格和维修需求，具体以车主和服务顾问沟通结果为准</span>
          </div>
          <div class="sure_box" style="margin-top: 20px;">
            <div class="sure" style="width: 235px;float: right;display: flex;">
              <span style="width: 80px;color: #000;font-size: 14px">服务顾问:</span>
              <div style="width: 160px;border-bottom: 1px solid #000;margin-left: 10px;"></div>
            </div>
            <div class="sure" style="margin-right: 30px;width: 235px;float: right;display: flex;">
              <span style="width: 80px;color: #000;font-size: 14px">客户签名:</span>
              <div style="width: 160px;border-bottom: 1px solid #000;margin-left: 10px;"></div>
            </div>
          </div>

        </div>
      </div>
    </div>




    <el-drawer
            title="分享溯源"
            left
            size="82%"
            :wrapperClosable="true"
            :visible.sync="showshareInfo"
            @opened="showSeeksGraph"
            direction="rtl">
      <div>
        <div style="height:calc(100vh - 100px);">
          <RelationGraph
                  ref="seeksRelationGraph"
                  :options="graphOptions"
                  :on-node-click="onNodeClick"
                  :on-line-click="onLineClick"
          />
        </div>
      </div>
    </el-drawer>



  </div>
</template>

<script>
  import { callbackify } from "util";
  import net from "../../assets/js/public";
  import tag_sa from '../../assets/img/tag_sa.png'
  import tag_address from '../../assets/img/address.png'
  import pos_tag_0 from '../../assets/img/pos_tag_0.png'
  import pos_tag_10 from '../../assets/img/pos_tag_10.png'
  import pos_tag_400 from '../../assets/img/pos_tag_400.png'
  import pos_tag_800 from '../../assets/img/pos_tag_800.png'
  import pos_tag_10_quoted from '../../assets/img/pos_tag_10_quoted.png'
  import QRCode from 'qrcodejs2'
  import Vue from 'vue'
  import VueClipboard from 'vue-clipboard2'
  import waterfall from 'vue-waterfall2'
  import RelationGraph from 'relation-graph'
  Vue.use(VueClipboard)
  Vue.use(waterfall)
  export default {
    components: {
      RelationGraph
    },
    data() {
      return {
        baseUrl: net.baseUrl,
        tag_sa: tag_sa,
        tag_address: tag_address,
        pos_tag_0: pos_tag_0,
        pos_tag_10: pos_tag_10,
        pos_tag_400: pos_tag_400,
        pos_tag_800: pos_tag_800,
        pos_tag_10_quoted: pos_tag_10_quoted,
        car_card_style: 'el_card_car',
        checkDay: '', //查询日期
        pickerDayOptions: { // 按天 当天、当月可选
          disabledDate(time) {
            return time.getTime() > Date.now();
          }
        },
        reasonArr: [],
        soledOptions: [
          { value: 800, label: '同意换件/维修' },
          { value: 400, label: '客户暂不处理' },
          { value: 0, label: '暂不登记' }],
        responseData: {},

        checkingList_: [],
        waitQuoteList_: [],
        waitCommunicateList_: [],
        finishList_: [],

        winHeight: '220',
        dossierDetailInfo: '',
        DossierDetailList: [],
        //销售结果
        showCommunicateResultDialog: false,
        DossierDetailListForFeedBack: [],

        dossierId: '',
        positionId: '',
        frameNumber: '',
        filterCarNumber: '',

        showCarDetailInfo: false,
        canFinishDossier: false,


        showQrDialog: false,
        partsInfoList: [],
        showPartsInfoSureEd: false,
        showPositionCheckDetail: false,//显示部位检测情况
        getCheckDetailTiltle: '',
        PositionCheckDetailData: {},

        dossierPartsAllPositionList: [],
        showPartsAllPosition: false,

        showBigImageUrl: '',
        showBigImage: false,

        lastLoadTime: (new Date()).toLocaleTimeString().replace(/\//g, '-'),
        timer: null,
        saId: 0,
        isOnlyShowSelfData: true,

        qrcode:'',

        printBox: false,
        positionInfoListPrint:[],
        printBoxList: false,
        dossierPartsAllPositionListPrint:[],

        positionHistoryCheckInfoList:[],
        showPositionHistoryCheckInfoList:false,
        positionHistoryHeight:'200',

        PositionHistoryStatus:[],
        showPositionHistoryStatus: false,

        showSearchPartsInfoSureEd:false, //查询工时、配件
        showSearchPartsInfoSureEdPart:[],
        showSearchPartsInfoSureEdWorkTime:[],


        activeName: 'first',

        showDetailBox:false, //显示详情
        dataListAll:[],
        showView:'card',
        DossierDetailListHeight:'200', //检测情况 表格高度

        showQuotationList:false, //报价清单列表
        showImgUrl: net.baseUrl + "admin/device/asset/file/getImg/",

        leftNum:0,
        dossierStatus:'', //档案状态
        priceNumSum:0, //报价清单合计

        videoList:[], //检测视频
        imgList:[],


        carIdBase:'', // 点击的车辆ID
        dossierIdBase:'', //点击的档案ID
        messageList:[],
        msg:'', //留言板内容
        belog:'',
        positionList:[],
        positionIdmsg:'',
        showMsgModel: false, //模板弹窗
        nochangeInput: false, //输入框不可点击
        nochangeModel: false, //模板按钮不可点击
        msgList:[],
        msgDetailList:[],
        dictionaryName:'', //字典名称
        multipleSelection: [], // 单字典选中的
        randomKey: Math.random(),
        messageHeight:'200px',
        drawerMsgHeight:'200',

        showshareInfo: false,
        currentCase: '纵向树状图谱',
        isShowCodePanel: false,
        graphOptions: {
          "backgrounImageNoRepeat": true,
          "defaultNodeBorderWidth": 2,
          "defaultLineShape": 4,
          "defaultNodeShape": 1,
          "defaultNodeWidth": "120",
          "defaultJunctionPoint": "tb",
          "defaultNodeColor": "rgba(57, 167, 253, 1)",
          "defaultLineColor": "rgba(78, 75, 75, 1)",
          "defaultNodeBorderColor": "#58D5FD",
          "layouts": [
            {
              "label": "中心",
              "layoutName": "tree",
              "layoutClassName": "seeks-layout-center",
              "defaultJunctionPoint": "border",
              "defaultNodeShape": 0,
              "from": "left"
            }
          ],
          "defaultNodeHeight": "60"
        },

        graph_json_data:'',


        // VHC 版本的参考标准 图片
        leftNum_stand: 0,

      }
    },
    created() {
      var signInfo = JSON.parse(sessionStorage.getItem("signInfo"));
      this.saId = signInfo.saId
      if (window.screen.availWidth <= 1980) {
        this.car_card_style = 'el_card_car';
      } else {
        this.car_card_style = 'el_card_car_max';
      }
      let obj = new Date();
      let month = obj.getMonth() + 1;
      if (month < 10) month = "0" + month;
      let day = obj.getDate();
      if (day < 10) day = "0" + day;
      this.checkDay = obj.getFullYear() + "-" + month + "-" + day;
      if (window.location.href.includes('127.0.0.1')) {
        this.checkDay = '2022-07-18'
      }
      // this.checkDay = '2022-07-18'
      this.getListData()
      this.getPositionList()
    },
    mounted() {
      window.onresize = () => {
        if (window.screen.availWidth <= 1980) {
          this.car_card_style = 'el_card_car';
        } else {
          this.car_card_style = 'el_card_car_max';
        }
      };

      this.timer = setInterval(() => {
        //需要定时执行的代码
        this.getListData();
      }, 10000)



      /*const permission = Notification.permission;
      if (permission === 'granted') {
        console.log('已经授权通知，可以进行你的通知啦！');
        var instanceNotification = new Notification("您有一条订单消息，请及时处理！", { "icon": "", "body": "快点击处理吧!", "requireInteraction": true });
      } else if (Notification.permission === 'default') {
        console.log('用户还未选择同意/拒绝');
        // 下一步请求用户授权
        Notification.requestPermission().then(function (permission) {
          if (permission === 'granted') {
            console.log('用户同意授权');
            // 随时可以显示通知
          } else if (permission === 'default') {
            console.log('用户关闭授权,可以再次请求授权');
          } else {
            console.log('用户拒绝授权,不能显示通知');
          }
        });
      } else {
        console.log('用户曾经拒绝授权,不能显示通知');
      }*/
    },
    destroyed() {
      //注销window.onresize事件
      window.onresize = null;
      if (this.timer != null) {
        clearInterval(this.timer)
        this.timer = null
      }
    },
    methods: {
      tableHeaderColor({ row, column, rowIndex, columnIndex }) {
        if (rowIndex === 0) {
          return "background-color:#99CCFF; color: #606266";
        }
      },
      cellClass(row) {
        if (row.columnIndex === 0) {
          return 'disabledCheck';
        }
      },
      trunRight(imageValueList){
        let dataLength = imageValueList.length
        let maxLeft = -150 * dataLength // -120
        let leftNum = this.leftNum
        leftNum = leftNum - 200 // -40
        if(maxLeft < leftNum){
          this.leftNum = leftNum
        }
      },
      trunLeft(){
        let leftNum = this.leftNum
        leftNum = leftNum + 200 > 0 ? 0 : leftNum + 200
        this.leftNum = leftNum
      },
      trunRightStandImg(){
        let maxLeft = -150 * 3
        let leftNum_stand = this.leftNum_stand
        leftNum_stand = leftNum_stand - 200 // -40
        if(maxLeft < leftNum_stand){
          this.leftNum_stand = leftNum_stand
        }
      },
      trunLeftStandImg(){
        let leftNum_stand = this.leftNum_stand
        leftNum_stand = leftNum_stand + 200 > 0 ? 0 : leftNum_stand + 200
        this.leftNum_stand = leftNum_stand
      },
      setRowStyle(row, column, rowIndex, columnIndex) {
        if(row.columnIndex == 0){
          return 'color: #0D0E12;font-weight: 500;font-size: 14px;'
        }else{
          return 'color: #0D0E12;font-weight: 400;'
        }
      },
      setRowStyleColor(row, column, rowIndex, columnIndex){
        return 'font-family: PingFang SC;font-style: normal;color: #0D0E12;font-weight: 500;font-size: 14px;'
      },
      // 获取所有部位
      getPositionList() {
        net.request("admin/sa/parts/getPositionList", "post").then(res => {
          if (res.code === 0) {
            this.positionList = res.data
          } else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      // 点击看板
      viewTabCard(){
        this.showView = 'card'
      },
      // 点击表格
      viewTabTable(){
        this.showView = 'table'
      },
      // 车辆历史检测情况表格
      setRowStyleColorNone(row, column, rowIndex, columnIndex){
        if (row.rowIndex == 0) {
          return "background-color:#F3F7FB; color: #364556;font-size: 14px;font-family: 'PingFang SC';font-weight: 500;";
        }else {
          return 'font-family: PingFang SC;font-style: normal;color: #0D0E12;font-weight: 500;font-size: 14px;'
        }
      },
      getHeaderStyleNone(){
        return "display:none";
      },
      showImageDialog(url) {
        this.showBigImageUrl = url;
        this.showBigImage = true
      },
      // 返回按钮
      backToCard(){
        this.showDetailBox = false
        this.showQuotationList = false

        this.$refs.qrcode.innerHTML = '';
        // this.$refs.qrcode_print.innerHTML = '';
        const codeHtml = document.getElementById("qrcode");
        const codeHtmlPrint = document.getElementById("qrcode_print");
        const codeHtmlPrintLisst = document.getElementById("qrcode_print_list");
        codeHtml.innerHTML = "";
        codeHtmlPrint.innerHTML = "";
        codeHtmlPrintLisst.innerHTML = "";


      },
      // 获取车辆信息
      getListData() {
        if (this.checkDay == '' || this.checkDay == null) {
          net.message(this, "请选择查询日期", "warning");
          return;
        } else {
          const params = {
            checkDay: this.checkDay,
          }
          net.request("admin/saUser/dossierQuote/getQuoteDossierListV2", "post", params).then(res => {
            if (res.code === 0) {
              this.responseData = res.data
              this.updateFilterList();
              this.lastLoadTime = (new Date()).toLocaleTimeString().replace(/\//g, '-');
            } else {
              net.message(this, res.msg, "warning");
            }
          });
          this.setWindowHeight()
        }
      },
      // 重置
      resetListData(){
        let obj = new Date();
        let month = obj.getMonth() + 1;
        if (month < 10) month = "0" + month;
        this.checkDay = obj.getFullYear() + "-" + month + "-" + obj.getDate();
        if (window.location.href.includes('127.0.0.1')) {
          this.checkDay = '2022-07-18'
        }
        this.filterCarNumber = ''
        this.getListData()
      },
      updateFilterList() {
        if (this.responseData.checkingList === null) return;
        let fcn = this.filterCarNumber;
        if (fcn === '' || fcn == undefined) {
          if (this.isOnlyShowSelfData) {
            this.checkingList_ = this.deepCopy(this.responseData.checkingList).filter(item => { return item.saId === this.saId })
            this.waitQuoteList_ = this.deepCopy(this.responseData.waitQuoteList).filter(item => { return item.saId === this.saId })
            this.waitCommunicateList_ = this.deepCopy(this.responseData.waitCommunicateList).filter(item => { return item.saId === this.saId })
            this.finishList_ = this.deepCopy(this.responseData.finishList).filter(item => { return item.saId === this.saId })

          } else {
            this.checkingList_ = this.deepCopy(this.responseData.checkingList)
            this.waitQuoteList_ = this.deepCopy(this.responseData.waitQuoteList)
            this.waitCommunicateList_ = this.deepCopy(this.responseData.waitCommunicateList)
            this.finishList_ = this.deepCopy(this.responseData.finishList)
          }
        } else {
          fcn = fcn.toUpperCase();
          if (this.isOnlyShowSelfData) {
            this.checkingList_ = this.deepCopy(this.responseData.checkingList).filter(item => { return item.saId === this.saId && item.carNumber.includes(fcn) })
            this.waitQuoteList_ = this.deepCopy(this.responseData.waitQuoteList).filter(item => { return item.saId === this.saId && item.carNumber.includes(fcn) })
            this.waitCommunicateList_ = this.deepCopy(this.responseData.waitCommunicateList).filter(item => { return item.saId === this.saId && item.carNumber.includes(fcn) })
            this.finishList_ = this.deepCopy(this.responseData.finishList).filter(item => { return item.saId === this.saId && item.carNumber.includes(fcn) })
          } else {
            this.checkingList_ = this.deepCopy(this.responseData.checkingList).filter(item => { return item.carNumber.includes(fcn) })
            this.waitQuoteList_ = this.deepCopy(this.responseData.waitQuoteList).filter(item => { return item.carNumber.includes(fcn) })
            this.waitCommunicateList_ = this.deepCopy(this.responseData.waitCommunicateList).filter(item => { return item.carNumber.includes(fcn) })
            this.finishList_ = this.deepCopy(this.responseData.finishList).filter(item => { return item.carNumber.includes(fcn) })
          }
        }
        this.checkingList_.forEach(item => {
          item.status = 'checking'
        })
        this.waitQuoteList_.forEach(item => {
          item.status = 'waitQuote'
        })
        this.waitCommunicateList_.forEach(item => {
          item.status = 'waitCommunicate'
        })
        this.finishList_.forEach(item => {
          item.status = 'finish'
        })

        var dataListAll = [];
        dataListAll= this.checkingList_.concat(this.waitQuoteList_).concat(this.waitCommunicateList_).concat(this.finishList_)

        for(let i = 0; i < dataListAll.length; i++){ // 合计正常项目数
          let positionStatusList = dataListAll[i].positionStatusList
          let nomanlNum = 0
          for(let j = 0; j < positionStatusList.length; j++){
            if(positionStatusList[j].checkStatus*1 === 0){
              nomanlNum++;
            }
          }
          dataListAll[i].nomanlNum = nomanlNum
        }
        this.dataListAll = dataListAll

        for(let i = 0; i < this.checkingList_.length; i++){ // 合计正常项目数
          let positionStatusList = this.checkingList_[i].positionStatusList
          let nomanlNum = 0
          for(let j = 0; j < positionStatusList.length; j++){
            if(positionStatusList[j].checkStatus*1 === 0){
              nomanlNum++;
            }
          }
          this.checkingList_[i].nomanlNum = nomanlNum
          this.checkingList_[i].status = 'checking'
        }
        for(let i = 0; i < this.waitQuoteList_.length; i++){ // 合计正常项目数
          let positionStatusList = this.waitQuoteList_[i].positionStatusList
          let nomanlNum = 0
          for(let j = 0; j < positionStatusList.length; j++){
            if(positionStatusList[j].checkStatus*1 === 0){
              nomanlNum++;
            }
          }
          this.waitQuoteList_[i].nomanlNum = nomanlNum
          this.waitQuoteList_[i].status = 'waitQuote'
        }
        for(let i = 0; i < this.waitCommunicateList_.length; i++){ // 合计正常项目数
          let positionStatusList = this.waitCommunicateList_[i].positionStatusList
          let nomanlNum = 0
          for(let j = 0; j < positionStatusList.length; j++){
            if(positionStatusList[j].checkStatus*1 === 0){
              nomanlNum++;
            }
          }
          this.waitCommunicateList_[i].nomanlNum = nomanlNum
          this.waitCommunicateList_[i].status = 'waitCommunicate'
        }
        for(let i = 0; i < this.finishList_.length; i++){ // 合计正常项目数
          let positionStatusList = this.finishList_[i].positionStatusList
          let nomanlNum = 0
          for(let j = 0; j < positionStatusList.length; j++){
            if(positionStatusList[j].checkStatus*1 === 0){
              nomanlNum++;
            }
          }
          this.finishList_[i].nomanlNum = nomanlNum
          this.finishList_[i].status = 'finish'
        }
      },
      deepCopy(src) {
        return JSON.parse(JSON.stringify(src))
      },
      getHeaderStyle() {
        return "background-color:#99CCFF; color: #606266; ";
      },
      // 获取车辆对应的各检测信息
      loadDossierDetail(item) {
        this.DossierDetailList = []
        this.dossierStatus = item.status //档案状态
        this.carIdBase = item.carId
        this.dossierIdBase = item.dossierId
        const params = {
          dossierId: item.dossierId
        }
        // 获取档案详情
        net.request("admin/saUser/dossierQuote/loadDossierDetail", "post", params).then(res => {
          if (res.code === 0) {
            // this.showCarDetailInfo = true // 弹窗
            // this.printBox = true
            this.showDetailBox = true //显示详情
            this.canFinishDossier = res.data.workStatus === 1000

            let listData = res.data
            listData.leftLogo = net.baseUrl + "admin/sa/organization/getImage?orgId="+listData.orgId+'&type=21'
            listData.rightLogo = net.baseUrl + "admin/sa/organization/getImage?orgId="+listData.orgId+'&type=22'
            this.dossierDetailInfo = listData

            let positionInfoList = listData.positionInfoList
            if (positionInfoList) {
              positionInfoList.forEach((item,index) => {
                item.money = (item.money / 100).toFixed(2)
                item.colIndex = index*1+1 //序号
              })
            }
            this.DossierDetailList = positionInfoList
            this.frameNumber = res.data.frameNumber ? res.data.frameNumber : "-"
            this.$nextTick(() => {
              let qrcode = new QRCode('qrcode', {
                width: 120,  // 二维码宽度
                height: 120, // 二维码高度
                text: res.data.qrCode
              })

              this.qrcode = qrcode
            });


            let newPositionInfoList = positionInfoList
            if(newPositionInfoList.length < 10){
              var count=10
              var dataOld1=new Array(count - newPositionInfoList.length).fill({})
              var data=[...newPositionInfoList,...dataOld1]
              this.positionInfoListPrint = data
            }else {
              this.positionInfoListPrint = newPositionInfoList
            }


            this.$nextTick(() => {
              let qrcode_print = new QRCode('qrcode_print', {
                width: 120,  // 二维码宽度
                height: 120, // 二维码高度
                text: res.data.qrCode
              })
            });
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight;
            this.DossierDetailListHeight = windiwHight - 300
          } else {
            net.message(this, res.msg, "warning");
          }
        });

        this.getMessageList()
      },
      // 关闭 检测情况 & 报价信息
      closeCarDetailInfo(){
        this.showCarDetailInfo = false
        this.printBox = false

        this.$refs.qrcode.innerHTML = '';
        // this.$refs.qrcode_print.innerHTML = '';
        const codeHtml = document.getElementById("qrcode");
        const codeHtmlPrint = document.getElementById("qrcode_print");
        const codeHtmlPrintLisst = document.getElementById("qrcode_print_list");
        codeHtml.innerHTML = "";
        codeHtmlPrint.innerHTML = "";
        codeHtmlPrintLisst.innerHTML = "";
      },
      doShowQrDialog() {
        let h5 = document.getElementById("qrcodeBig");
        if (h5 != undefined) h5.innerHTML = "";
        let qrCode = this.dossierDetailInfo.qrCode
        this.showQrDialog = true
        this.$nextTick(() => {
          new QRCode('qrcodeBig', {
            width: 200,  // 二维码宽度
            height: 200, // 二维码高度
            text: qrCode
          })
        });
      },

      getSummariesWhenPreviewCheck(n,v) {
        const sums = [];
        sums[1] = "合计";
        let total = 0;
        this.DossierDetailList.forEach((item) => {
          total += Number(item.money);
        });
        total = total === 0 ? 0 : total.toFixed(2);
        sums[4] = total;
        return sums;
      },
      getSummariesWhenPreviewQuote(param) {
        const sums = [];
        sums[0] = "合计";
        let total = 0;
        this.partsInfoList.forEach((item) => {
          total += Number(item.price * item.numFloat);
        });
        total = total === 0 ? 0 : total.toFixed(2);
        sums[3] = total;
        return sums;
      },
      getSummariesWhenPreviewQuote2(param) {
        const sums = [];
        sums[0] = "合计";
        let total = 0;
        this.dossierPartsAllPositionList.forEach((item) => {
          total += Number(item.price * item.numFloat);
        });
        total = total === 0 ? 0 : total.toFixed(2);
        sums[4] = total;
        return sums;
      },
      getSummariesWhenPreviewQuote3(){
        const sums = [];
        sums[0] = "合计";
        let total = 0;
        this.dossierPartsAllPositionList.forEach((item) => {
          total += Number(item.price * item.numFloat);
        });
        total = total === 0 ? 0 : total.toFixed(2);
        sums[6] = total;
        return sums;
      },
      getSummariesWhenFinished(n,v) {
        const sums = [];
        sums[1] = "合计";
        let total = 0;
        this.DossierDetailList.forEach((item) => {
          total += Number(item.money);
        });
        total = total === 0 ? 0 : total.toFixed(2);
        sums[3] = total;
        return sums;
      },


      // 查看已报价
      loadPartsInfoSureEd(row) {
        this.positionId = row.positionId
        const params = {
          positionId: row.positionId,
          dossierId: this.dossierDetailInfo.dossierId
        }
        net.request("admin/saUser/dossierQuote/loadQuoteInfoList", "post", params).then(res => {
          if (res.code === 0) {
            let partsInfoList = res.data
            partsInfoList.forEach(item => {
              item.price = (item.price / 100).toFixed(2)
            })

            this.partsInfoList = partsInfoList
            this.showPartsInfoSureEd = true
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      // 查询 报价情况
      searchPartsInfoSureEd(row){
        net.request("admin/saUser/dossierQuote/loadPartsInfo", "post", {positionId: row.positionId}).then(res => {
          if (res.code === 0) {
            let partsInfoList = res.data.dataList

            let showSearchPartsInfoSureEdPart = []
            let showSearchPartsInfoSureEdWorkTime = []

            partsInfoList.forEach(item => {
              item.price = (item.price / 100).toFixed(2)
              if(item.showType*1 === 0){ //配件
                showSearchPartsInfoSureEdPart.push(item)
              }else {// 工时
                showSearchPartsInfoSureEdWorkTime.push(item)
              }
            })



            this.showSearchPartsInfoSureEdPart = showSearchPartsInfoSureEdPart
            this.showSearchPartsInfoSureEdWorkTime = showSearchPartsInfoSureEdWorkTime
            this.showSearchPartsInfoSureEd = true

          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },

      // 修改价格
      changePirce(updateType,row){
        const params = {
          dossierId: row.dossierId,
          positionId: row.positionId
        }
        let body = []
        body.push({
          dossierId: row.dossierId,
          positionId: row.positionId,
          showIndex: row.showIndex,
          showType: row.showType,
          partsId: row.partsId,
          price: row.price * 100,
          numFloat: row.numFloat,
          note: row.note,
          updateType: updateType*1
        })

        net.request("admin/saUser/dossierQuote/updateQuoteInfo", "post", params, body).then(res => {
          if (res.code === 0) {
            net.message(this, res.msg, "success");
            this.showQuoteAllPosition()
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      //查看检测详情
      loadCheckDetailInfo(row) {
        this.videoList = []
        const params = {
          dossierId: this.dossierDetailInfo.dossierId,
          positionId: row.positionId,
        }
        net.request("admin/saUser/dossierQuote/loadCheckDetail", "post", params).then(res => {
          if (res.code === 0) {
            this.showPositionCheckDetail = true
            this.getCheckDetailTiltle = res.data.positionName + ' 检测情况'
            if (res.data.imageVersion > 0) {
              let url2 = net.baseUrl+'/admin/saUser/image/getStandardImage/' + row.positionId + "/" + res.data.imageVersion + "/" + this.dossierDetailInfo.orgId;
              res.data.standardImage = url2
            }
            res.data.imageValueList.forEach(item => {
              let url = net.baseUrl+'admin/saUser/image/getImg/' + item.valueText;
              item.imageUrl = url
            })
            let videoValueList = res.data.videoValueList
            if(videoValueList.length > 0){
              this.getVideoDetail(videoValueList)
            }else {
              this.videoList = []
            }
            this.PositionCheckDetailData = res.data


          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      // 查询检测视频
      getVideoDetail(item){
        let videoValueList = item
        let videoList = []
        let imgList = this.PositionCheckDetailData.imageValueList
        for(let i = 0; i < videoValueList.length; i++){
          let videoId = videoValueList[i].videoId
          let data = ''
          net.request("admin/sa/video/getVideoPlayInfo", "post", {videoId: videoId}).then(res => {
            if (res.code === 0){
              data = res.data
              videoList.push(data)
              this.videoList = videoList

            }
          })
        }
        this.imgList = imgList
      },
      // 部位历史检测情况
      loadPositionHistoryCheckInfoList(row){
        const params = {
          dossierId: this.dossierDetailInfo.dossierId,
          positionId: row.positionId,
        }
        net.request("admin/saUser/dossierQuote/loadPositionHistoryCheckInfoList", "post", params).then(res => {
          if (res.code === 0) {
            let list = res.data
            list.forEach(item => {
              item.money = (item.money / 100).toFixed(2)
            })
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight;
            this.positionHistoryHeight = windiwHight - 165
            this.positionHistoryCheckInfoList = list
            this.showPositionHistoryCheckInfoList = true


          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      // 车辆历史检测情况
      loadPositionHistoryStatus(){
        const params = {
          dossierId: this.dossierDetailInfo.dossierId
        }
        net.request("admin/saUser/dossierQuote/loadPositionHistoryStatus", "post", params).then(res => {
          if (res.code === 0) {
            let head = res.extra3
            let haedArr = {}
            for(let i = 0; i < head.length; i++){
              let keyStr = 'td'+i
              haedArr[keyStr] = head[i]
            }
            let list = res.data
            let dataList = [haedArr]
            for(let i = 0; i < list.length; i++){
              let dataObj = {}
              for(let j = 0; j < list[i].length; j++){
                let keyStr = 'td'+j
                dataObj[keyStr] = list[i][j]
              }
              dataList.push(dataObj)
            }
            this.PositionHistoryStatus = dataList
            this.showPositionHistoryStatus = true
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      //显示车辆的报价详情列表
      showQuoteAllPosition() {
        const params = {
          dossierId: this.dossierDetailInfo.dossierId
        }
        net.request("admin/saUser/dossierQuote/loadAllQuoteInfoList", "post", params).then(res => {
          if (res.code === 0) {
            let list = res.data
            list.forEach((item , index) => {
              item.price = (item.price / 100).toFixed(2)
              item.colIndex = index*1+1 //序号
            })
            this.dossierPartsAllPositionList = list
            // this.showPartsAllPosition = true
            this.showQuotationList = true //显示表格

            let newPositionInfoList = list
            if(newPositionInfoList.length < 10){
              var count=10
              var dataOld1=new Array(count - newPositionInfoList.length).fill({})
              var data=[...newPositionInfoList,...dataOld1]
              this.dossierPartsAllPositionListPrint = data
            }else {
              this.dossierPartsAllPositionListPrint = newPositionInfoList
            }


            this.$nextTick(() => {
              let qrcode_print_list = new QRCode('qrcode_print_list', {
                width: 120,  // 二维码宽度
                height: 120, // 二维码高度
                text: this.dossierDetailInfo.qrCode
              })
            });

            let priceNumSum = 0
            for(let i = 0; i < list.length; i++){
              priceNumSum += (list[i].price*1) * (list[i].numFloat*1)
            }
            this.priceNumSum = priceNumSum.toFixed(2) //总价
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight;
            this.DossierDetailListHeight = (windiwHight - 300)/2 //表格高度

          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      //收起报价清单详情
      hideQuoteAllPosition(){
        this.showQuotationList = false
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight;
        this.DossierDetailListHeight = windiwHight - 300
      },
      // 关闭 车辆（配件/工时）清单
      closePartsAllPosition(){
        this.showPartsAllPosition = false
        this.printBoxList = false

        const codeHtmlPrintLisst = document.getElementById("qrcode_print_list");
        codeHtmlPrintLisst.innerHTML = "";
      },
      //商谈结束 改变状态
      finishCommunicateStatus() {
        const params = {
          dossierId: this.dossierDetailInfo.dossierId
        }
        net.request("admin/saUser/dossierQuote/loadDossierDetail", "post", params).then(res => {
          if (res.code === 0) {
            let DossierDetailListForFeedBack = res.data.positionInfoList
            DossierDetailListForFeedBack.forEach(item => {
              item.money = (item.money /100).toFixed(2)
              item.price = item.price /100
              item.belongTo = item.belongTo+'' || 0
            })
            this.DossierDetailListForFeedBack = DossierDetailListForFeedBack
            this.showCommunicateResultDialog = true
          } else {
            net.message(this, res.msg, "warning");
          }
        });
        //  获取失销原因
        net.request("admin/sa/reason_config/queryReason","post", { orgId: this.dossierDetailInfo.orgId }).then(res => {
          if(res.code === 0){
            let data = res.data
            data.forEach(item => {
              item.reasonId *= 1
            })
            this.reasonArr = res.data;
          }else {
            net.message(this, "获取数据失败", "warning");
          }
        })
      },
      // 全部异常已换
      abnormalReplaced(){
        let DossierDetailListForFeedBack = this.DossierDetailListForFeedBack
        DossierDetailListForFeedBack.forEach(item => {
          if(item.tag *1 === 10){
            item.usFeedback = 800
          }
        })
        this.DossierDetailListForFeedBack = DossierDetailListForFeedBack
      },
      // 全部异常不换
      abnormalNoChange(){
        let DossierDetailListForFeedBack = this.DossierDetailListForFeedBack
        DossierDetailListForFeedBack.forEach(item => {
          if(item.tag *1 === 10){
            item.usFeedback = 400
          }

        })
        this.DossierDetailListForFeedBack = DossierDetailListForFeedBack
      },
      //提交商谈结束的反馈数据
      doFinishCommunicateStatus() {
        const params = {
          dossierId: this.dossierDetailInfo.dossierId
        }
        let body = [];
        this.DossierDetailListForFeedBack.forEach(item => {
          let p = {};
          p.positionId = item.positionId;
          p.usFeedback = item.usFeedback | 0;
          p.reason = item.reason | 0;
          p.dealFeedback = item.dealFeedback | 0;
          p.price = item.price*100 | 0;
          p.belongTo = item.usFeedback*1===800 ? item.belongTo*1 : 0;
          body[body.length] = p;
        });
        console.log("参数-------",body)

        // const hasWrong = body.some(position => position.usFeedback*1 === 800 && position.belongTo*1 <= 0);
        //
        // if(hasWrong){
        //   net.message(this, "同意换件的部位请选择销售类型", "warning");
        //   return;
        // }
        net.request("admin/saUser/dossierQuote/saveFeedBack", "post", params, body).then(res => {
          if (res.code === 0) {
            net.message(this, "登记成功", "success")
            this.DossierDetailListForFeedBack = null
            this.showCommunicateResultDialog = false
            //外面检测详情 对话框也要刷新
            this.loadDossierDetail(this.dossierDetailInfo)
          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },


      // 获取留言模板
      getMsgModel(){
        net.request("admin/sa/message/dictionary/getDictionaryList", "post", ).then(res => {
          if(res.code === 0){
            this.showMsgModel = true
            this.msgList = res.data
            this.getMsgDetail(res.data[0])
            this.multipleSelection = []
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight;
            this.drawerMsgHeight = windiwHight - 250
          }
        })
      },
      getMsgDetail(row, column, event){
        let params = {
          dictionaryId: row.dictionaryId
        }
        net.request("admin/sa/message/dictionary/typeValueList", "post", params).then(res => {
          if(res.code === 0){
            this.msgDetailList = res.data
            this.dictionaryName = row.dictionaryName

            this.randomKey = Math.random()
            // this.selectedPreExisting(this.multipleSelection)
          }
        })
      },

      handleSelectionChange(val) {
        this.multipleSelection = val;
      },

      // //选中table已有数据
      // selectedPreExisting (rows) {
      //   if (rows.length > 0) {
      //     //这里使用this.$nextTick是防止表格未渲染完成就执行，导致无法添加选中效果
      //     this.$nextTick(() => {
      //       rows.forEach(row => {
      //         //判断row是存在当前msgDetailList
      //         let selectedItem = this.msgDetailList.find(item => item.dictionaryItemId == row.dictionaryItemId)
      //         this.$refs.multipleTable.toggleRowSelection(selectedItem);
      //       });
      //     })
      //   } else {
      //     this.$refs.multipleTable.clearSelection();
      //   }
      // },
      // //表格单选
      // select (selection, row) {
      //   //因为翻页之后，点选时selection会出现undefined,所以这里需要进行判断
      //   //这里可以通过判断选择selection中有没有row，就可以判断出是增加还是删减
      //   if (selection && selection.find(item => item && (item.dictionaryItemId == row.dictionaryItemId))) {
      //     this.addRows([row])
      //   } else {
      //     this.deleteRows([row])
      //   }
      // },
      //
      // //添加选中
      // addRows (rows) {
      //   rows.forEach(row => {
      //     //过滤，当multipleSelection有此条数据时，则直接返回，不执行添加
      //     if (this.multipleSelection.find(item => item.dictionaryItemId == row.dictionaryItemId)) { return }
      //     this.multipleSelection.push(row)
      //   });
      // },
      // //取消选中
      // deleteRows (rows) {
      //   //当multipleSelections为空数组时，不执行删除
      //   if (this.multipleSelection.length == 0) { return }
      //   let multipleSelection = ''
      //   rows.forEach(row => {
      //     this.multipleSelection = this.multipleSelection.filter(item => item.dictionaryItemId !== row.dictionaryItemId)
      //   })
      // },


      // 确定选中
      selectedMsg(){
        let multipleSelection = this.multipleSelection
        let msg = ''
        for(let i = 0; i < multipleSelection.length; i++){
          msg += multipleSelection[i].text
        }
        if(msg){
          this.nochangeInput = true
          this.nochangeModel = false
        }
        this.msg = msg
        this.showMsgModel = false

      },
      // 输入留言板文本
      inputMsg(){
        if(this.msg){ //有输入值
          this.nochangeInput = false
          this.nochangeModel = true
        }else {
          this.nochangeInput = false
          this.nochangeModel = false
        }
      },
      // 发送留言
      sureAddMsg(){
        if(this.msg == '' || this.msg == null){
          net.message(this, "请输入留言内容", "warning");
          return;
        }
        if( this.belog == ''||this.belog==null || (this.belog == 2 && (this.positionIdmsg == '' || this.positionIdmsg == null))){
          net.message(this, "请选择留言属性", "warning");
          return;
        }
        let body = {
          dossierId : this.dossierIdBase,
          carId : this.carIdBase,
          msg : this.msg,
          positionId : this.positionIdmsg,
        }
        net.request('admin/sa/message/addMessage','post',null, body).then(res=> {
          if(res.code == 0){
            net.message(this, res.msg, "success");
            this.getMessageList()
            this.msg = ''
            this.belog = ''
            this.positionId = ''
            this.nochangeInput = false
            this.nochangeModel = false
          }
        })
      },

      // 全部标为已读
      readMsg(){
        let messageList = this.messageList
        let noReadList = []
        for(let i = 0; i < messageList.length; i++){
          if(messageList[i].hasRead*1 !== 1){
            noReadList.push({messageId:messageList[i].messageId})
          }
        }
        net.request("admin/sa/message/addMessageLog", "post", null, noReadList).then(res => {
          if(res.code === 0){
            net.message(this, res.msg, "success");
            this.getMessageList()
          }
        })
      },
      // 清空留言板
      clearMsg(){
        this.msg = ''
        this.belog = ''
        this.positionIdmsg = ''
        this.nochangeInput = false
        this.nochangeModel = false
      },
      // 下拉选择部位
      selectPosition(){
        this.belog = '2'
      },
      changeBelog(){
        this.positionIdmsg = ''
      },
      // 获取留言列表
      getMessageList(){
        net.request("admin/sa/message/getMessageList", "post", {dossierId : this.dossierIdBase}).then(res => {
          if(res.code === 0){
            this.messageList = res.data
            const windiwHight = document.documentElement.clientHeight || document.body.clientHeight // 可视屏幕高度
            this.messageHeight = windiwHight - 600 +'px'

          }
        })
      },



      // 分享溯源
      shareDetail(row){
        const params = {
          dossierId: row.dossierId,
        }
        net.request("admin/sa/share/dossier", "post", params).then(res => {
          if (res.code === 0) {
            if(res.data){
              this.showshareInfo = true
              let nodes = res.data.nodes
              const graph_json_data = {
                rootId: 'a',
                nodes: nodes,
                lines:res.data.lines,
              }
              this.graph_json_data = graph_json_data
            }else {
              net.message(this, "暂无访问数据", "warning");
            }

          } else {
            net.message(this, res.msg, "warning");
          }
        });
      },
      showSeeksGraph(){
        let graph_json_data = this.graph_json_data
        this.$refs.seeksRelationGraph.setJsonData(graph_json_data, (graphInstance) => {
          // 这些写上当图谱初始化完成后需要执行的代码
        });
      },

      onNodeClick(nodeObject, $event) {
        console.log('onNodeClick:', nodeObject);
      },
      onLineClick(lineObject, linkObject, $event) {
        console.log('onLineClick:', lineObject);
      },






      onCopy(e) {
        // 复制成功时的回调函数
        net.message(this, "内容已复制到剪切板！", "success");
      },
      onError(e) {
        // 复制失败时的回调函数
        net.message(this, "抱歉，复制失败！", "warning");
      },
      // 删除线
      delLine({ row, rowIndex, }) {
        if (row.makeSureResult * 1 == 101) return 'del_line'
      },
      // 设置滚动高度
      setWindowHeight() {
        const windiwHight = document.documentElement.clientHeight || document.body.clientHeight; // 可视屏幕高度
        this.winHeight = windiwHight - 300;
      },




    },
    watch: {
      //监听table这个对象
      dossierPartsAllPositionListPrint: {
        // 立即监听
        immediate: true,
        handler() {
          this.$nextTick(() => {
            const tds = document.querySelectorAll(
                    "#printBoxList .el-table__footer-wrapper tr>td"
            );
            // colSpan合并列
            tds[0].colSpan=5;
            tds[0].style.textAlign='right'
            tds[1].style.display='none'
            tds[2].style.display='none'
            tds[3].style.display='none'
            tds[4].style.display='none'
            tds[6].style.borderRight='1px dashed #000'
          });
        },
      },

      /*DossierDetailList: function () {
        let _this = this;
        this.$nextTick(() => {
          let html = _this.$refs.DossierDetailList.$refs.footerWrapper
                  .querySelector(".el-table__footer")
                  .querySelectorAll("td")[6]
                  .querySelector(".cell");
          html.innerHTML = "<el-button type='success' size='small' style='width: 80px;height: 32px;background:#409EFF;color: #fff;line-height: 32px; display:inline-block;border-radius: 4px; font-size:12px;' >报价清单</el-button>";
          html.onclick = () => {
            _this.showQuoteAllPosition();
          };

          let html2 = _this.$refs.DossierDetailList.$refs.footerWrapper
                  .querySelector(".el-table__footer")
                  .querySelectorAll("td")[7]
                  .querySelector(".cell");
          html2.innerHTML = "<el-button type='success' size='small' style='width: 80px;height: 32px;background:#409EFF;color: #fff;line-height: 32px; display:inline-block;border-radius: 4px; font-size:12px;' >打印</el-button>";

        });

      },*/
      // DossierDetailList(){
      //     let _this = this;
      //     this.$nextTick(() => {
      //       let html = _this.$refs.DossierDetailList.$refs.footerWrapper
      //               .querySelector(".el-table__footer")
      //               .querySelectorAll("td")[6]
      //               .querySelector(".cell");
      //       html.innerHTML = "<el-button type='success' size='small' style='width: 80px;height: 32px;background:#409EFF;color: #fff;line-height: 32px; display:inline-block;border-radius: 4px; font-size:12px;' >报价清单</el-button>";
      //       html.onclick = () => {
      //         _this.showQuoteAllPosition();
      //       };
      //     });
      // },


    },
  };
</script>

<style lang='less' scoped>
  #print_box .print_con {
    page-break-after: always;//
    padding: 0;
  }
  #printBoxList .print_con {
    page-break-after: always;//
    padding: 0;
  }

  a,
  button,
  input,
  select,
  textarea {
    outline: 0;
    text-decoration:none;
  }

  /deep/ .el-table th.el-table__cell {
    background: #F3F7FB !important;
    color: #364556;
  }

  // 深度选择器 去掉全选按钮
  /deep/ .el-table .disabledCheck .cell .el-checkbox__inner {
    display: none;
  }

  /deep/ .el-table .disabledCheck .cell::before {
    content: '';
    text-align: center;
    line-height: 37px;
  }


  .detail_box{
    background: #F5F8FF;
    width: 100%;
    height: 100%;
    margin-top: 24px;
    .detail_info_box {
      width: 98%;
      height: calc(100vh - 94px);
      min-height: 720px;
      /*min-height: 908px;*/
      background: #FFFFFF;
      border-radius: 8px;
      .left {
        width: 597px;
        height: 100%;
        background: #fff;
        border-right: 1px solid rgba(113, 129, 161, 0.1);
        float: left;
        .back_box {
          overflow: hidden;
          width: 100%;
          .back_btn {
            float: left;
            width: 84px;
            height: 36px;
            margin-top: 12px;
            margin-bottom: 12px;
            margin-left: 12px;
            text-align: center;
            line-height: 36px;
            background: rgba(255, 255, 255, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 4px;
            font-size: 14px;
            a {
              color: #364556;
            }
          }
          .history_btn {
            float: right;
            width: 104px;
            height: 36px;
            display: block;
            margin-right: 12px;
            margin-top: 12px;
            background: #2B54FC;
            box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
            border-radius: 4px;

            font-weight: 500;
            font-size: 14px;
            line-height: 36px;
            text-align: center;
            a {
              color: #FFFFFF;
            }
          }
        }
        .info {
          position: relative;
          .car_info {
            .item {
              display: flex;
              margin-left: 12px;
              .carNumber {
                font-weight: 500;
                font-size: 24px;
                line-height: 18px;
                color: #0D0E12;
              }
              .status {
                width: 49px;
                height: 24px;
                margin-top: 14px;
                background: #2981D3;
                border-radius: 14px;
                font-weight: 500;
                font-size: 11px;
                line-height: 24px;
                text-align: center;
                color: #FFFFFF;
                margin-left: 20px;
              }
            }
            .mile {
              font-weight: 400;
              font-size: 14px;
              line-height: 22px;
              color: #787E86;
              text-align: left;
              margin-left: 12px;
            }
            .sa{
              font-size: 14px;
              line-height: 22px;
              color: #0D0E12;
              text-align: left;
              margin-left: 12px;
              display: flex;
              img {
                margin-right: 8px;
              }
            }
          }
          .qr_code{
            span {
              font-size: 12px;
              color: #0D0E12;
            }
          }
        }
        /*留言板*/
        .message_box {
          background: rgba(148, 170, 204, 0.08);
          border-radius: 6px;
          margin: 12px;
          padding: 0 12px;
          .top_box {
            height: 36px;
            line-height: 36px;
            font-size: 18px;
            font-weight: 600;
            .title {
              .el-icon-brush {
                transform:rotate(180deg)
              }
            }
          }
          .block {
            overflow-y: auto;
            min-height: 200px;
            .meaasge_item {
              margin-bottom: 12px;
              p {
                font-size: 12px;
                color: #787E86;
                line-height: 24px;
              }
              .item_box {
                display: flex;
                align-items: center;
                .card_item {
                  /*width: calc(100% - 50px);*/
                  position: relative;
                  width: 100%;
                  text-align: left;
                  font-size: 14px;
                  line-height: 22px;
                  padding: 12px;
                  background: #FFFFFF;
                  border: 1px solid rgba(113, 129, 161, 0.1);
                  box-shadow: 0px 20px 40px rgba(170, 170, 170, 0.16);
                  border-radius: 8px;
                  .position_name {
                    height: 22px;
                    font-size: 12px;
                    color: #2B54FC;
                  }
                  .user_info {
                    font-size: 12px;
                    line-height: 24px;
                    color: #787E86;
                    text-align: right;
                  }
                  .has_read {
                    width: 50px;
                    position: absolute;
                    right: 0;
                    top: 6px;
                    text-align: center;
                    font-size: 14px;
                  }
                }

              }
            }
          }
          .input_box {
            padding-bottom: 12px;
            margin-top: 8px;
            font-size: 14px;
            overflow: hidden;
            .input_top {
              height: 14px;
              margin-bottom: 8px;
              span {
                float: left;
              }
              a {
                float: right;
                color: red;
              }
            }

            .select_bottom_msg {
              display: flex;
              line-height: 40px;
              margin-top: 8px;
              font-size: 14px;
              .option_box_msg {
                margin-left: 8px;
              }
              .select_box_msg {
                margin-left: 8px;
              }
            }

            .btn_box {
              margin-top: 12px;
            }
          }
        }
      }
      .right{
        float: left;
        width: calc(100% - 598px);
        height: 100%;
        background: #fff;
        .test_situation {
          .situation_left{
            float: left;
            display: flex;
            .dot{
              width: 4px;
              height: 10px;
              background: #2B54FC;
              border-radius: 3px;
              margin-left: 24px;
              margin-top: 33px;
            }
            .title {
              font-weight: 500;
              font-size: 16px;
              line-height: 73px;
              color: #0D0E12;
              margin-left: 8px;
              display: flex;
            }
          }
          .situation_right {
            float: right;
            display: flex;
            .btn {
              display: block;
              width: 131px;
              height: 36px;
              margin-top: 24px;
              margin-right: 24px;
              background: rgba(148, 170, 204, 0.08);
              border: 1px solid #E3E7ED;
              border-radius: 4px;
              color: #364556;
              font-weight: 500;
              font-size: 14px;
              line-height: 36px;
              text-align: center;
            }
          }
          .print_quote_btn {
            float: right;
            width: 103px;
            height: 36px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 4px;
            margin-right: 24px;
            line-height: 36px;
            margin-top: 16px;
            font-size: 14px;
            color: #364556;
          }
        }
        .right_list_content {
          .status_box {
            display: flex;
          }
          .abnormal_text { //异常
            width: 38px;
            height: 24px;
            display: block;
            text-align: center;
            background: #E04066;
            border-radius: 14px;
            color: #FFFFFF;
            font-size: 11px;
            line-height: 24px;
          }
          .normal_text { //正常
            width: 38px;
            height: 24px;
            background: #29D3BF;
            border-radius: 14px;
            display: block;
            text-align: center;
            color: #FFFFFF;
            font-size: 11px;
            line-height: 24px;
          }
          .wanging_text { // 警示
            width: 38px;
            height: 24px;
            background: #E1BD3E;
            border-radius: 14px;
            display: block;
            text-align: center;
            color: #FFFFFF;
            font-size: 11px;
            line-height: 24px;
          }

          .department_text { // 车间
            width: 46px;
            height: 24px;
            margin-left: 8px;
            background: linear-gradient(299deg, rgba(94, 177, 255, 1) 0%, rgba(128, 52, 252, 1) 100%), rgba(204, 204, 204, 1);
            border-radius: 8px;
            display: block;
            text-align: center;
            color: #FFFFFF;
            font-size: 11px;
            line-height: 24px;
          }
          .doit_btn {
            /*width: 120px;*/
            /*height: 28px;*/
            margin-right: 8px;
            line-height: 28px;
            font-size: 12px;
            background: rgba(148, 170, 204, 0.08);
            border: 1px solid #E3E7ED;
            border-radius: 14px;
            color: #364556;
            text-align: center;
            transform: scale(0.9);
            padding: 0 12px;
          }
        }
      }
    }
  }

  .tab_header_box {
    -webkit-user-select:none;
    -moz-user-select:none;
    -ms-user-select:none;
    user-select:none;
    width: 100%;
    height: 36px;
    margin-top: 24px;
    margin-bottom: 24px;
    overflow: hidden;
    .view_tab {
      width: 76px;
      height: 36px;
      float: left;
      background: rgba(148, 170, 204, 0.08);
      border: 1px solid #E3E7ED;
      font-size: 14px;
      color: #364556;
      line-height: 36px;
      text-align: center;
      overflow: hidden;
    }
    .active_view_tab {
      width: 76px;
      height: 36px;
      background: #242E42;
      box-shadow: 0px 4px 12px rgba(36, 46, 66, 0.24);
      color: #FFFFFF;
    }
    .reload_box {
      float: right;
      line-height: 36px;
    }
  }
  .view_tab_box {
    background: #fff;
    padding-left: 24px;
    -ms-overflow-style: none;
    overflow: -moz-scrollbars-none;
  }
  .view_tab_box::-webkit-scrollbar { width: 0 !important }

  .danger_box {
    width: 38px;
    height: 24px;
    display: block;
    border-radius: 14px;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 11px;
    text-align: center;
    line-height: 24px;
  }
  // 检测详情按钮
  .detail_btn_box {
    /*width: 72px;*/
    /*height: 28px;*/
    color: #364556;
    background: rgba(148, 170, 204, 0.08);
    border: 1px solid #E3E7ED;
    border-radius: 14px;
    font-weight: 400;
    font-size: 12px;
    // line-height: 28px;
  }
  // 检测详情弹窗
  .text_box {
    overflow: hidden;
    .text_content {
      width: 50%;
      float: left;
      p {
        font-size: 16px;
        color: #0D0E12;
        margin-bottom: 16px;
      }
      div{
        font-size: 14px;
        color: #787E86;
        margin-bottom: 32px;
        line-height: 22px;
      }
      .risk_explain {
        /*margin-bottom: 64px;*/
      }
    }
    .refer_to_content {
      width: 46%;
      float: right;
      p {
        font-size: 16px;
        color: #0D0E12;
        margin-bottom: 16px;
      }
      /*普通版本*/
      .version_first {
        height: 210px;
        border-radius: 5px;
        overflow: hidden;
        img {
          height: 100%;
        }
      }
      /*VHC版本*/
      .img_item {
        height: 181px;
        background: #F6F8FB;
        border-radius: 6px;
        display: flex;
        overflow: hidden;
        .icon_box {
          width: 36px;
          height: 36px;
          display: block;
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid #E3E7ED;
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          margin: 72px 9px;

        }
        .img_list {
          width: calc(100% - 72px);
          float: left;
          margin: 11px 0;
          overflow: hidden;
          .img_flex_box {
            height: 100%;
            display: flex;
            .img_flex_box_item{
              display: flex;
              .label_img {
                text-align: center;
                img {
                  height: 140px;
                  margin-right: 16px;
                  border-radius: 5px;
                  overflow: hidden;
                }
                .label_box {
                  height: 20px;
                  display: flex;
                  line-height: 20px;
                  img {
                    width: 20px;
                    height: 20px;
                    margin-left: 30%;
                    margin-right: 4px;
                  }

                }
                /*p {
                  font-size: 14px;
                  line-height: 20px;
                }*/
              }

            }
          }
        }
      }
    }
  }
  .details_box {
    overflow: hidden;
    .detail_info {
      width: 35%;
      float: left;
      p {
        font-size: 16px;
        color: #0D0E12;
        margin-bottom: 16px;
      }
      div{
        font-size: 14px;
        color: #787E86;
        margin-bottom: 32px;
        line-height: 22px;
      }
      .detection {
        margin-bottom: 32px;
        div{
          display: flex;
          flex-direction: column;
          margin-bottom: 4px;
        }
      }
    }
    .img_box {
      width: 60%;
      float: right;
      p {
        font-size: 16px;
        color: #0D0E12;
        margin-bottom: 16px;
      }
      .img_item {
        height: 181px;
        background: #F6F8FB;
        border-radius: 6px;
        display: flex;
        overflow: hidden;
        .icon_box {
          width: 36px;
          height: 36px;
          display: block;
          background: rgba(255, 255, 255, 0.08);
          border: 1px solid #E3E7ED;
          border-radius: 4px;
          text-align: center;
          line-height: 36px;
          margin: 72px 9px;

        }
        .img_list {
          width: calc(100% - 72px);
          float: left;
          margin: 11px 0;
          overflow: hidden;
          .img_flex_box {
            display: flex;
            img {
              height: 100%;
              margin-right: 16px;
            }
          }
        }
      }
    }
  }
  // 配件、工时 标题
  .dia_box_dot {
    .dot{
      width: 4px;
      height: 10px;
      background: #2B54FC;
      border-radius: 3px;
      /*margin-left: 24px;*/
      float: left;
      margin-top: 15px;
      margin-right: 8px;
    }
    span {
      display: block;
      line-height: 40px;
      text-align: center;
      float: left;
      font-family: 'PingFang SC';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      color: #0D0E12;
    }
  }
  .operate_btn {
    border: 1px solid #2B54FC;
    color: #2B54FC;
    margin-right: 10px;
    width: 104px;
    height: 36px;
    display: block;
    line-height: 36px;
    border-radius: 4px;
    font-size: 14px;
    text-align: center;
  }






  .searchContent {
    background: #fff;
    padding-left: 24px;
    padding-top: 24px;
    // margin: 24px 0px 0 24px;
    // padding-top: 24px;
    .p_select {
      display: flex;
      padding: 0 24px 24px 0;
      font-size: 12px;
      float: left;
      .search_label{
        font-family: 'PingFang SC';
        font-style: normal;
        margin-right: 12px;
        font-weight: 500;
        font-size: 14px;
        line-height: 40px;
        color: #787E86;
        white-space:nowrap
      }
      .el-input , .el-select{
        width: 160px;
      }
    }
    .serach_btn_box {
      float: right;
      .search_btn {
        width: 76px;
        height: 36px;
        line-height: 36px;
        background: #2B54FC;
        box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
        border-radius: 4px;
        font-size: 14px;
        color: #FFFFFF;
      }
      .clean_btn {
        width: 76px;
        height: 36px;
        line-height: 36px;
        background: rgba(148, 170, 204, 0.08);
        border: 1px solid #E3E7ED;
        border-radius: 4px;
        font-size: 14px;
        color: #364556;
      }
    }

    .search_btn {
      width: 76px;
      height: 36px;
      line-height: 36px;
      background: #2B54FC;
      box-shadow: 0px 4px 12px rgba(71, 134, 192, 0.24);
      border-radius: 4px;
      color: #FFFFFF;
      font-size: 14px;
    }
  }

  .list_content {
    // margin-left: 24px;
    background: #fff;
  }

  .pagination {
    position: relative;
    margin-top: 10px;
    height: 36px;

    .el-pagination {
      position: absolute;
      right: 24px;

      .el-pager li:not(.disabled) {
        .active {
          background: #009688 !important;
        }
      }
    }
  }

  .el-pagination.is-background .el-pager li:not(.disabled).active {
    background: #009688;
  }

  .select_box {
    text-align: left;
    margin-bottom: 10px;

    .select_title {
      display: inline-block;
      width: 100px;
      text-align: right;
      margin-right: 20px;
    }
  }

  .el-image__inner {
    width: 32px;
    height: 44px;
    line-height: 1;
    text-align: center;
    vertical-align: bottom;
  }

  .print_table {
    border: 1px dashed #333;
  }

  #printBoxList {
    /deep/.el-table .el-table__footer-wrapper .el-table__cell {
      border-top: 1px dashed #000;

      .cell {
        color: #000;
      }
    }

    /*/deep/.el-table .el-table__footer-wrapper .has-gutter tr:nth-last-child(1){*/
    /*border-right: 1px dashed #000;*/
    /*}*/
  }

  .car_list_box {
    width: 100%;
    height: calc(100vh - 296px);
    overflow-y: auto;

    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    /*justify-content: center;*/
    align-items: flex-start;
  }
  .data_car {
    width: 414px;
    min-height: 223px;
    /*float: left;*/
    margin-top: 23px;
    margin-right: 24px;
    background: #FFFFFF;
    border: 1px solid rgba(113, 129, 161, 0.1);
    box-shadow: 0px 20px 40px rgba(170, 170, 170, 0.16);
    border-radius: 8px;
    .header_box {
      width: 100%;
      margin-top: 15px;
      overflow: hidden;
      .carinfo{
        float: left;
        display: flex;
        flex-flow: column;
        text-align: left;
        .carNumber{
          font-family: 'PingFang SC';
          font-style: normal;
          font-weight: 500;
          font-size: 16px;
          line-height: 22px;
          color: #0D0E12;
          margin-left: 23px;
        }
        .mile{
          font-weight: 400;
          font-size: 12px;
          line-height: 22px;
          color: #787E86;
          margin-left: 23px;
        }
      }
      .btn_box{
        display: block;
        float: right;
        margin-right: 23px;
        width: 60px;
        height: 24px;
        line-height: 24px;
        background: #29D3BF;
        border-radius: 14px;
        font-size: 11px;
        color: #FFFFFF;
      }
      .btn_box_category { // 车间
        display: block;
        float: right;
        margin-right: 4px;
        width: 60px;
        height: 24px;
        line-height: 24px;
        background: linear-gradient(299deg, rgba(94, 177, 255, 1) 0%, rgba(128, 52, 252, 1) 100%), rgba(204, 204, 204, 1);
        border-radius: 8px;
        font-size: 11px;
        color: #FFFFFF;
      }
    }
    .test_box {
      overflow: hidden;
      .item_box {
        width: 60px;
        height: 67px;
        text-align: center;
        float: left;
        margin-right: 23px;
        margin-left: 23px;
        margin-bottom: 8px;
        .number {
          /*width: 33px;*/
          height: 45px;
          font-weight: 600;
          font-size: 32px;
          line-height: 45px;
          text-align: center;
          color: #0D0E12;
        }
        .label {
          /*width: 24px;*/
          height: 22px;
          /*margin-left: 7px;*/
          font-weight: 400;
          font-size: 12px;
          line-height: 22px;
          text-align: center;
          color: #787E86;
        }
        .danger_text {
          color: #E04066;
        }
      }
    }
    .option_box {
      width: 100%;
      .left {
        float: left;
        width: 310px;
        margin-left: 23px;
        .option_name {
          // width: 48px;
          height: 28px;
          padding: 0 12px;
          margin-right: 8px;
          margin-bottom: 8px;
          background: rgba(148, 170, 204, 0.08);
          border: 1px solid #E3E7ED;
          border-radius: 14px;
          font-size: 12px;
          line-height: 28px;
          text-align: center;
          color: #364556;
          float: left;
        }
      }
      .right{
        float: right;
        font-weight: 400;
        font-size: 14px;
        line-height: 28px;
        color: #0D0E12;
        margin-right: 23px;
      }
    }

  }


  /*表格 查看详情按钮*/
  .update_btn {
    display: block;
    width: 54px;
    height: 28px;
    background: rgba(148, 170, 204, 0.08);
    border: 1px solid #E3E7ED;
    border-radius: 14px;
    font-size: 12px;
    color: #364556;
    text-align: center;
  }

  .msg_detail_box {
    width: calc(100% - 24px);
    margin-top: 24px;
    border: 1px solid #eee;
    padding: 24px;
    border-radius: 8px;
    text-align: left;
    font-size: 14px;
  }
</style>

<style>


  .el-radio input[aria-hidden="true"] {
    display: none !important;
  }

  .el-radio:focus:not(.is-focus):not(:active):not(.is-disabled) .el-radio__inner {
    box-shadow: none !important;
  }


  @media print {
    @page {
      size:  auto;
    }
    body, html {
      height: auto !important;
    }
  }
  /*未读提示*/
  .el-badge__content.is-fixed {
    top: 10px !important;
  }
  /*  抽屉 标题 */
  .el-drawer__header {
    text-align: left;
    font-family: 'PingFang SC';
    font-style: normal;
    font-weight: 500;
    font-size: 18px;
    color: #0D0E12;
  }
  .el-table__row {
    position: relative;
  }

  /* 删除线*/
  .del_line::after {
    content: no-open-quote;
    position: absolute;
    top: 51%;
    left: 0;
    width: 100%;
    border-bottom: 1px solid #ff000069;
  }

  .el-checkbox__inner {
    width: 18px;
    height: 18px;
    border-color: #000;
  }

  .el-checkbox__inner::after {
    height: 10px;
    left: 6px;
  }

  .el-input__inner {
    /* border: 1px solid #908d8d; */
  }

  /**新设计 */

  .el-row-1 {
    height: calc(100vh - 169px);
  }

  .el-col-1 {
    height: calc(100vh - 169px);
    margin-top: 10px;
    margin-bottom: 10px;
  }

  .colSet {
    height: calc(100vh - 209px);
  }



  .car_list_set {
    /* header 62px  margin 6px*2 */
    height: calc(100vh - 199px - 62px - 12px);
    overflow: auto;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .el_card_car {
    width: 185px;
    height: fit-content;
    max-width: 185px;
    margin: 6px 3px;
  }

  .el_card_car_max {
    width: 264px;
    height: fit-content;
    max-width: 264px;
    margin: 6px 3px;
  }

  .carNumber {
    font-weight: bold;
    font-size: 16px;
  }

  .car_info_row {
    text-align: left;
  }

  .car_info_position_set {
    display: flex;
    float: left;
    justify-content: left;
    flex-wrap: wrap;
    padding-top: 5px;
    padding-bottom: 5px;
  }

  .car_info_position_set .item-content {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding-top: 4px;
    padding-left: 4px;
    padding-right: 4px;
    padding-bottom: 4px;
    margin-left: 2px;
    margin-top: 2px;
    height: auto;
    font-size: 8px;
    color: #686868;
    box-sizing: border-box;
    border: 1px solid #ccc;
    float: left;
    border-radius: 4px;
  }

  .car_info_label {
    width: 66px;
    line-height: 24px;
    height: 14px;
    font-size: 12px;
    text-align: left;
    font-weight: bold;
    display: block;
    float: left;
  }

  .car_info_value {
    line-height: 24px;
    height: 14px;
    text-align: left;
    font-size: 14px;
  }

  /** */
  /*.el-form-item__label {
    height: 24px;
    line-height: 24px;

  }*/

  .el-form-item__content {
    height: 24px;
    line-height: 24px;

  }


  .el-dialog {
    display: flex;
    flex-direction: column;
    margin: 0 !important;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    /*height:600px;*/
    max-height: calc(100% - 30px);
    max-width: calc(100% - 30px);
  }

  .el-dialog .el-dialog__body {
    flex: 1;
    overflow: auto;
  }

  .tagImage {
    width: 16px;
    height: 16px;
  }


  .tagImage2 {
    width: 15px;
    height: 15px;
  }

  .tagPositionName {
    margin-left: 0px;
    font-size: 12px;
    transform: scale(0.8);
    -webkit-transform-origin-x: 1;
    -webkit-transform: scale(0.8);
  }

  .clearFix::after {
    content: "";
    display: block;
    clear: both;
  }
  .el-input__prefix {
    left: 135px;
  }

  /*tab样式*/
  .el-tabs__item {
    color: #787E86;
  }
  .el-tabs__item.is-active {
    color: #0D0E12 !important;
  }
  .el-tabs__active-bar {
    height: 4px;
    background: #2B54FC;
    border-radius: 3px;
  }
  .el-checkbox__input.is-checked .el-checkbox__inner,
  .el-checkbox__input.is-indeterminate .el-checkbox__inner {
    border-color: #2B54FC !important;
    background-color: #2B54FC !important;
  }

  .el-checkbox__input.is-checked + .el-checkbox__label {
    color: #0D0E12 !important;
  }

  /*.el-checkbox__label {*/
    /*color: #0D0E12 !important;*/
  /*}*/
</style>
